/********************************/
/* Snackbar                     */
/********************************/
(function (window) {
	var Snackbar = {};
	// Any snackbar that is already shown
	Snackbar.current = null;

	Snackbar.show = function (message, actionText, action) {
		if (Snackbar.current) {
			Snackbar.current.style.opacity = 0;
			setTimeout(
				function () {
					var $parent = this.parentElement;
					if ($parent)
						// possible null if too many/fast Snackbars
						$parent.removeChild(this);
				}.bind(Snackbar.current),
				500
			);
		}
		
		
		Snackbar.snackbar = document.createElement('div');
		Snackbar.snackbar.className = 'paper-snackbar';
		Snackbar.snackbar.innerHTML = message;

		if (actionText) {
			let actClass = 'btn btn-success action';
			if (Array.isArray(actionText) == false) {
				actionText = [actionText];
				if (action) action = [action];
			} else if (actionText.length > 1) {
				Snackbar.snackbar.style.flexDirection = 'column';
				actClass = 'btn btn-success action actionTwice';
			}

			const divEle = document.createElement('div');
			Snackbar.snackbar.appendChild(divEle);
			actionText.forEach(function (item, index) {
				//if (!action) {
				//  action = snackbar.dismiss.bind(snackbar);
				//}
				if (item != ' ') {
					var actionButton = document.createElement('button');
					actionButton.className = actClass;
					actionButton.innerHTML = item;
					if (action && action[index]) actionButton.addEventListener('click', action[index]);
					actionButton.addEventListener('click', function () {
						Snackbar.close();
					});
					divEle.appendChild(actionButton);
				}
			});
		} else {
			//#am changed: automatic dismiss only if no actiontext
			setTimeout(
				function () {
					if (Snackbar.current === this) {
						Snackbar.current.style.opacity = 0;
					}
				}.bind(Snackbar.snackbar),
				5000
			);
		}

		Snackbar.snackbar.addEventListener(
			'transitionend',
			function (event, elapsed) {
				if (event.propertyName == 'opacity' && this.style.opacity == '0') {
					this.parentElement.removeChild(this);
					if (Snackbar.current === this) {
						Snackbar.current = null;
					}
				}
			}.bind(Snackbar.snackbar)
		);

		Snackbar.current = Snackbar.snackbar;

		document.body.appendChild(Snackbar.snackbar);

		// In order for the animations to trigger, I have to force the original style to be computed, and then change it.
		//window.getComputedStyle(Snackbar.snackbar).bottom;
		Snackbar.snackbar.style.bottom = '0px';
		Snackbar.snackbar.style.opacity = 0.9;
	};

	Snackbar.close = function () {
		if (Snackbar.current) Snackbar.current.style.opacity = 0;
	};

	window.Snackbar = Snackbar;

	//sw laden /xxx ruth abschalten

	if ('serviceWorker' in navigator && typeof Cache !== 'undefined' && Cache.prototype.addAll) {
		//sw.js mit parameter um eine neue Version zu erzwingen
		navigator.serviceWorker.register('./sw.js').then(function(reg) {
			// ganz Deutschland
			console.log('Service Worker Registered');
		});
	}
	
	
})(window);

if (!Element.prototype.matches) {
	Element.prototype.matches =
		Element.prototype.matchesSelector ||
		Element.prototype.mozMatchesSelector ||
		Element.prototype.msMatchesSelector ||
		Element.prototype.oMatchesSelector ||
		Element.prototype.webkitMatchesSelector ||
		function (s) {
			var matches = (this.document || this.ownerDocument).querySelectorAll(s),
				i = matches.length;
			while (--i >= 0 && matches.item(i) !== this) {}
			return i > -1;
		};
}
isOnline = true;
hasMap = true;

_folder = 'daten/';
_eleTiles = [];

_rPrintTexte = {};
//_rPrintTexte.Toleranz = new Object();
_rPrintTexte.R = {};
_rPrintTexte.K = {};
_rPrintTexte.LS = {};
_rPrintTexte.C = {};
_rPrintTexte.P = {};

// Json-Daten
_cweinTab = null;
_chopfenTab = null;
//_cmiscanthusTab = null;
//_csilphieTab = null;

//_cdauerbracheTab = null;
_cfruchtfolgeTab = null;
_cHinweis = null;				 

_kbodenartTab = null;
_kzustandsstufeTab = null;
_ksteinbedeckungschaetzungTab = null;
_kfeinbodenschaetzungTab = null;
_kfeinbodenandererbodenTab = null;
_rfaktorGemeinden = null;

_rLKRGem = null; // Nominatim-Ergebnis
// eingegebene Hanglaenge und Neigung die fuer den P-Faktor wieder verwendet werden
// xxx evtl. nicht global?
_gesLaenge = 0;
_gesNeig = 0;
_lsHinweis = null;

//_rPosition = [48.3969, 11.7433]; // Initial Freising
//_rPosition = [49.2119429, 12.1401077]; // Initial 5452_4510
_rPosition = [];

// Pixel-Werte vom Bodenartendreieck
// Bei Originalgroesse gelten folgende Werte
_xTon0 = 51; //
_xTon100 = 396;
_ySchluff0 = 354;
_ySchluff100 = 9;

//Schluessel fuer Karten
BAkey = '';

//Abfrage ob Install abfangen
homescreenPrompt = null;

document.addEventListener('DOMContentLoaded', function () {
	console.log('welcome');
	_handleInstall();

	//ueberpruefen ob Online
	_setIsOnline();
	window.addEventListener('online', _setIsOnline);
	window.addEventListener('offline', _setIsOnline);

	//Lizenzkey für Maps holen
	loadData('./licensekey.json', '', function (key) {
		BAkey = key;
	});

	//Wenn BackButton gedrückt, dann zur Startseite
	window.addEventListener('popstate', function (event) {
		loadPage('home');
	});

	//promise polyfill setzen falls nicht native vorhanden
	if (!window.Promise) {
		window.Promise = Promise;
	}

	//#am NRW
	//Schauen ob Bundesland in URL vorbelegt
	const queryString = window.location.search;
	if (queryString.toLowerCase().includes('nrw')) localStorage.setItem('bl', 'Nordrhein-Westfalen');
	if (queryString.toLowerCase().includes('bayern')) localStorage.setItem('bl', 'Bayern');

	//Daten zum Bundesland und den Höhenkacheln aus dem Localstorage holen
	_setBundesland(localStorage.getItem('bl'));
	if (!isOnline) {
		var tmp = localStorage.getItem('tiles');
		if (tmp) _eleTiles = localStorage.getItem('tiles').split(',');
		else _eleTiles = [];
	}

	/*
    if (L.Browser.edge) {
        // xxx unbefriedigendes Ergebnis
        addHTMLFragment("syslib/js/stickyfill.min.js",null, stickyHack,null,null); // z.B. initC
    }
	*/

	if (!hasMap) {
		document.getElementById('nav-collapsible-links-LS-map').classList.add('hidden');
	}

	if (L.Browser.mobile) {
		//offline freigeben
		if (hasMap && isOnline) {
			toggleDownloadDelete(true);
			DB.Util.isDownloaded().then(function (ev) {
				if (ev == true) {
					toggleDownloadDelete(false);
				}
			});
			document.querySelector('#nav-links-offline').classList.remove('hidden');
		}

		//swipe einschalten
		//swipe fuer Faktorenwechsel
		_onSwipe(
			document.querySelector('main'),
			function () {
				//kein Swipe mehr gewünscht
				return;

			},
			function () {
				//kein Swipe mehr gewünscht
				return;

			},
			{ xMin: 20, minDelta: 70, stopId: 'map' }
		);

		//Swipe fuer Menue
		_onSwipe(
			document.querySelector('main'),
			null,
			function () {
				console.log('swipe');
				document.getElementById('nav--super-vertical-responsive').checked = true;
			},
			{ xMax: 20 }
		);
		_onSwipe(
			document.querySelector('.nav--super-vertical'),
			function () {
				console.log('swipezurueck');
				document.getElementById('nav--super-vertical-responsive').checked = false;
			},
			{ xMax: 200 }
		);
	}

	// Laden der R-Faktorn zu Beginn
	loadData(_folder + 'rfaktorgemeinden.json', 'R-gemeinden', insertDataR);
});

function _handleInstall() {
	//installevent abfangen
	window.addEventListener('beforeinstallprompt', function (e) {
		// Stash the event so it can be triggered later.
		e.preventDefault();
		homescreenPrompt = e;
	});

	const installFunc = function () {
		if (homescreenPrompt && localStorage.getItem('install') != 'true') {
			const clearInstall = function () {
				homescreenPrompt = null;
				localStorage.setItem('install', 'true');
				document.querySelector('#section-home').removeEventListener('click', installFunc);
				document.querySelector('#formelbtn').removeEventListener('click', installFunc);
				document.querySelector('aside').removeEventListener('click', installFunc);
			};

			Snackbar.show(
				'Bei öfterer Verwendung ist es sinnvoll, ABAGinteraktiv als Anwendung auf Ihrem Endgerät zu installieren',
				['Installieren', 'Abbruch'],
				[
					function () {
						homescreenPrompt.prompt();
						clearInstall();
					},
					function () {
						clearInstall();
					}
				]
			);
		}
	};
	//events zum anzeigen der Installationsanweisung
	document.querySelector('#section-home').addEventListener('click', installFunc);
	document.querySelector('#formelbtn').addEventListener('click', installFunc);
	document.querySelector('aside').addEventListener('click', installFunc);
}

//************************************************
//** Allgemein
//************************************************
function _setBundesland(bl) {
	if (bl == null) bl = 'Bayern';
	localStorage.setItem('bl', bl);

	// #am NRW
	// Bayern und NRW besitzen Karten
	hasMap = (bl == 'Bayern' || bl == 'Nordrhein-Westfalen');

	//wenn Bundesland nicht Bayern, dann TileEinstellungen zurücksetzen
	if (!hasMap) localStorage.setItem('tiles', '');
}

function toggleDownloadDelete(download) {
	//#am NRW offline abschalten
	document.querySelector('#download-data').classList.add('hidden');
	document.querySelector('#delete-data').classList.add('hidden');
	return;


}

function _onSwipe(ele, lFunc, rFunc, options) {
	var xDown = null;
	var yDown = null;
	var doTouchBreak = null;
	var opt = { xMin: 0, xMax: 1000000, minDelta: 20 };

	var setOptions = function (obj, options) {
		for (var i in options) {
			obj[i] = options[i];
		}
		return obj;
	};

	opt = setOptions(opt, options);

	var handleTouchEnd = function (evt) {
		doTouchBreak = null;
	};

	var handleTouchStart = function (evt) {
		//ueberpruefen ob StopId im BubblingPath vorhanden
		var isValid = true;
		if (evt.srcElement.type == 'range') {
			isValid = false;
		} else if (evt.srcElement.id == opt.stopId) {
			isValid = false;
		}

		//swiping starten wenn keine StopId
		if (isValid == true) {
			xDown = evt.touches[0].clientX;
			yDown = evt.touches[0].clientY;
		} else {
			xDown = null;
			yDown = null;
		}
	};

	var handleTouchMove = function (evt) {
		if (!xDown || !yDown || doTouchBreak) {
			return;
		}

		var xUp = evt.touches[0].clientX;
		var yUp = evt.touches[0].clientY;

		var xDiff = xDown - xUp;
		var yDiff = yDown - yUp;

		// horizontal swipe
		if (Math.abs(xDiff) > Math.abs(yDiff)) {
			if (xDiff > opt.minDelta) {
				/* left swipe */
				if (lFunc) lFunc();
				doTouchBreak = true;
			} else if (xDiff < -opt.minDelta && xDown > opt.xMin && xDown < opt.xMax) {
				/* right swipe */
				if (rFunc) rFunc();
				doTouchBreak = true;
			}
			// vertical swipe
		}

		if (doTouchBreak) {
			xDown = null;
			yDown = null;
		}
	};

	//removeeventlistener funktioniert nicht, da nicht selbe referenz auf z.b. handleTouchStart
	var eventOpt = { capture: false, passive: true };
	if (opt.stop) {
		ele.removeEventListener('touchstart', handleTouchStart, eventOpt);
		ele.removeEventListener('touchmove', handleTouchMove, eventOpt);
		ele.removeEventListener('touchend', handleTouchEnd, eventOpt);
		ele.removeEventListener('touchcancel', handleTouchEnd, eventOpt);
	} else {
		ele.addEventListener('touchstart', handleTouchStart, eventOpt);
		ele.addEventListener('touchmove', handleTouchMove, eventOpt);
		ele.addEventListener('touchend', handleTouchEnd, eventOpt);
		ele.addEventListener('touchcancel', handleTouchEnd, eventOpt);
	}
}

function _setIsOnline() {
	isOnline = true;
	if (!navigator.onLine) {
		isOnline = false;
		return;
	}

	//bei Chrome ist isOnline true nicht unbedingt true
	var testConnection = function () {
		// make sync-ajax request
		var xhr = new XMLHttpRequest();
		// phone home
		xhr.open('HEAD', '/', false); // async=false
		try {
			xhr.send();
			isOnline = true;
		} catch (e) {
			// throws NETWORK_ERR when disconnected
			isOnline = false;
		}
	};
}

function stickyHack(args, rawFile) {
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.text = rawFile;
	document.body.appendChild(script);

	makeSticky(document.getElementsByClassName('sticky'));
}

function makeSticky(stickyElements) {
	if (typeof Stickyfill == 'undefined') return;
	for (var i = 0; i < stickyElements.length; i++) {
		Stickyfill.add(stickyElements[i]);
	}
}

function isPageLoaded(val) {
	var faktor = getFaktor(val); // Welcher Faktor
	if (document.getElementById('section-' + faktor).innerHTML.trim() != '') return true;
	return false;
}

function loadPage(val) {
	//speichern dass ein Seitenwechsel stattgefunden hat => fuer BackKnopf
	if (val != 'home' && val != 'print') history.pushState(null, document.title, location.href);

	// index.html, die einzelnen Faktoren und Methoden koennen da aufgerufen werden
	var faktor = getFaktor(val); // Welcher Faktor
	//console.log("loadPage " + faktor);

	var arr = Array.prototype.slice.call(document.getElementsByClassName('faktorSection'));
	arr.forEach(function (ele) {
		if (getSubstr(ele.getAttribute('id'), 'section-') == faktor) {
			var func;
			if (ele.innerHTML.trim() == '') {
				// Unterseite laden
				// bei Uebergabe von mehreren args, diese als Array []);
				func = 'init' + faktor;
				addHTMLFragment('html/' + faktor.toLowerCase() + '.html', 'section-' + faktor, window[func], null, val); // z.B. initC
			} else {
				//eval("load" + faktor + "('" + val + "')"); // xxx hiesse aber, dass alles schon geladen ist!
				func = 'load' + faktor;
				window[func](val); // xxx hiesse aber, dass alles schon geladen ist!
			}
			if (val != 'print') {
				ele.classList.remove('hidden');
			}
		} else {
			if (val != 'print') {
				ele.classList.add('hidden');
			}
		}
	});

	// Schliessen des Menues
	document.getElementById('nav--super-vertical-responsive').checked = false;
}

function loadPagefromMenu(ele, val) {
	//console.log(window.innerWidth + " " + ele.checked);
	if (ele.checked == false) return;
	if (window.innerWidth < 1200) return; // nicht reagieren, wenn Menue nicht staendig sichtbar
	loadPage(val);
}

function displayFaktorMethode(val) {
	// http://materializecss.com/color.html

	var bg = {
		home: '#e0e0e0', // grey lighten-2
		info: '#e0e0e0', //grey lighten-2
		print: '#e8cebf', //Logo-Farbe
		A: '#e8cebf', //Logo-Farbe
		R: '#80cbc4', //teal lighten-3
		K: '#bcaaa4', //braun lighten-3 //
		LS: '#ffee58', //yellow lighten-2
		C: '#c5e1a5', //light-green lighten-3
		P: '#dce775' //lime lighten-2
	};
	/*
    var bghome = "#e0e0e0"; // grey lighten-2
    var bginfo = "#e0e0e0"; //grey lighten-2

    var bgprint = "#e8cebf"; //Logo-Farbe
    var bgA = "#e8cebf"; //Logo-Farbe

    var bgR = "#80cbc4"; //teal lighten-3
    var bgK = "#bcaaa4"; //braun lighten-3 // 
    var bgLS = "#ffee58"; //yellow lighten-2
    var bgC = "#c5e1a5"; //light-green lighten-3
    var bgP = "#dce775"; //lime lighten-2
	*/

	var faktor = getFaktor(val);
	var methode = getMethode(val);
	var arr;
	// An und ausschalten der Sektionen der Faktoren

	if (methode != null) {
		arr = Array.prototype.slice.call(document.getElementsByClassName('section-' + faktor));
		arr.forEach(function (ele) {
			if (ele.getAttribute('id').indexOf(methode) !== -1) {
				ele.classList.remove('hidden');
			} else {
				ele.classList.add('hidden');
			}
		});
	}
	// Runde Buttons
	arr = Array.prototype.slice.call(document.getElementsByClassName('faktor'));
	arr.forEach(function (ele) {
		if (ele.getAttribute('id').indexOf(faktor) == 0) {
			ele.classList.add('bg--dark--' + faktor);
		} else {
			ele.classList.remove('bg--dark--' + ele.getAttribute('id'));
		}
	});

	document.body.style.background = bg[faktor];
	//document.body.style.background = eval("bg" + faktor);

	// Highlight der richtigen Methode
	displayRadFaktorMethode(faktor, methode, faktor + 'Rad');

	// Synchronisation des Menues
	var navEle = document.getElementById('nav-collapsible-' + faktor);
	if (navEle == null) return;

	/*
    arr = Array.prototype.slice.call(document.getElementById("nav").getElementsByTagName("input"));
    arr.forEach(function(ele) {
        if (ele.checked == true && ele != navEle) { // alle offenen Menues zuklappen
            ele.click();
        }
    });
		*/

	if (navEle.checked == false) {
		// Betreffendes Menue ggf. aufklappen
		navEle.click();
	}

	arr = Array.prototype.slice.call(document.getElementsByClassName('nav-collapsible-links'));
	arr.forEach(function (ele) {
		for (var i = 0, len = ele.children.length; i < len; i++) {
			var id = getSubstr(ele.children[i].id, 'nav-collapsible-links-');
			id = id.substring(0, id.indexOf('-'));
			if (id == faktor) {
				//ele.children[i].classList.remove("bg--light--" + id);
				ele.children[i].classList.remove('nav-collapsible-links-active');
			}
		}
	});
	//console.log(val);
	if (document.getElementById('nav-collapsible-links-' + val)) document.getElementById('nav-collapsible-links-' + val).classList.add('nav-collapsible-links-active');
	//document.getElementById("nav-collapsible-links-" + val).classList.add("bg--light--" + faktor);
}

function displayRadFaktorMethode(faktor, methode, rad) {
	if (methode == null) return;
	var arr = Array.prototype.slice.call(document.getElementsByClassName(rad));
	arr.forEach(function (ele) {
		if (ele.getAttribute('id').indexOf(methode) !== -1) {
			ele.classList.add('radchecked');
			ele.classList.add('bg--dark--' + faktor);
			ele.classList.remove('radunchecked');
			ele.classList.remove('bg--' + faktor);
		} else {
			ele.classList.remove('radchecked');
			ele.classList.remove('bg--dark--' + faktor);
			ele.classList.add('radunchecked');
			ele.classList.add('bg--' + faktor);
		}
	});
}

function scrollToSection(ele) {
	//https://stackoverflow.com/questions/8922107/javascript-scrollintoview-middle-alignment
	// Damit die Buttons auch noch sichtbar sind ist scrollIntoView nicht geeignet, da oben abgeschnitten
	//ele.scrollIntoView(true);
	var rect = ele.getBoundingClientRect();
	console.log(rect.top);
	if (rect.top < 150) return;
	//var absoluteElementTop = rect.top + window.pageYOffset;
	window.scrollTo(0, rect.top - 100);
}

function initInputRange(selector, sliderChangeFunc, sliderStopFunc, slidertxtFunc) {
	// Convertierung HTMLcollection Array, gut oder doch lieber durchloopen?
	// https://www.w3schools.com/jsref/met_document_getelementsbyclassname.asp
	//var arr = Array.prototype.slice.call( document.getElementById("section-" + faktor).getElementsByTagName("input") );
	var arr = Array.prototype.slice.call(selector);
	arr.forEach(function (ele) {
		if (ele.type == 'range') {
			ele.addEventListener('mousedown', function () {
				ele.addEventListener('mousemove', sliderChangeFunc);
				ele.addEventListener('mouseup', sliderStopFunc);
			});
			ele.addEventListener('touchstart', function (evt) {
				ele.addEventListener('touchmove', sliderChangeFunc);
				ele.addEventListener('touchend', sliderStopFunc);
			});
			ele.addEventListener('change', sliderChangeFunc);
		}
		if (ele.classList.contains('slidertxt')) {
			ele.addEventListener('keyup', slidertxtFunc);
			ele.addEventListener('click', slidertxtFunc); // z.B. bei Firefox erscheint ein Pfeil nach unten/oben

			// damit Werte Slider-Text sicher uebereinstimmen
			var sliderId = ele.id.substr(ele.id.indexOf('slidertxt-') + 10);
			var value = document.getElementById(sliderId).value;
			ele.value = value;
		}
	});
}

function sliderStop(e) {
	e.target.removeEventListener('mousemove', sliderChange);
	e.target.removeEventListener('mouseup', sliderStop);
	e.target.removeEventListener('touchmove', sliderChange);
	e.target.removeEventListener('touchend', sliderStop);
}

function sliderChange(e) {
	document.getElementById('slidertxt-' + e.target.id).value = e.target.value;
	var func = 'set' + getFaktor(e.target.id) + 'Faktor';
	window[func](e.target.id);
	//var func = "set" + getFaktor(e.target.id) + "Faktor('" + e.target.id + "')";
	//eval(func);
}

function slidertxtChange(e) {
	var value = e.target.value;

	// xxx Es ist gerade ein Punkt eingegeben worden // Komma
	//  if (value.indexOf(".") == value.length - 1 || value.indexOf(",") == value.length - 1) return;
	//	if (value.indexOf(".") != -1 || value.indexOf(",") != -1) {
	//	}
	//if (isNaN(value)) value = 0;

	var sliderId = e.target.id.substr(e.target.id.indexOf('slidertxt-') + 10);
	var sliderEle = document.getElementById(sliderId);
	var maxVal = parseFloat(sliderEle.getAttribute('max'));
	value = value > maxVal ? maxVal : value;

	sliderEle.value = value;
	var func = 'set' + getFaktor(sliderId) + 'Faktor';
	window[func](sliderId);
}

function setSlidersMax100Prozent(slider, sliders) {
	var valSum = 0;
	var nodeList = document.getElementById(sliders).getElementsByTagName('input');
	var i, ele;

	for (i = 0, len = nodeList.length; i < len; i++) {
		ele = nodeList[i];
		if (ele.type == 'range') {
			valSum += parseInt(ele.value);
		}
	}

	if (valSum > 100) {
		// man kommt ueber 100
		var val = valSum - 100;
		for (i = 0, len = nodeList.length; i < len; i++) {
			ele = nodeList[i];
			if (ele.type == 'range') {
				if (ele.getAttribute('id') != slider.id && parseInt(ele.value) > 0) {
					// Es kann etwas abgezogen werden
					eleVal = ele.value - val;
					ele.value = eleVal;
					document.getElementById('slidertxt-' + ele.getAttribute('id')).value = eleVal;
					//return false;
					break;
				}
			}
		}
	}
}

/*  
function setSlidersMax100Prozent_alt(val1, slider2Id, slider3Id) {
	var slider2 = document.getElementById(slider2Id);
	var val2 = parseInt(slider2.value);
	var val3 = 0;
	var slider3 = null;
	if (typeof slider3Id != 'undefined') {
		slider3 = document.getElementById(slider3Id);
		val3 = parseInt(slider3.value);
	}
	if (val1 + val2 + val3 > 100) {
		var newVal = Math.max(0, 100 - val1 - val3);
		slider2.value = newVal;
		document.getElementById('slidertxt-' + slider2Id).value = newVal;
		if (newVal == 0 && typeof slider3Id != 'undefined') {
			slider3.value = 100 - val1;
			document.getElementById('slidertxt-' + slider3Id).value = newVal;
		}
	}
}
*/  

function initABAGhelp(selector) {
	var arr = Array.prototype.slice.call(selector);
	arr.forEach(function (ele) {
		ele.addEventListener('click', function (evt) {
			ABAGhelp(this.getAttribute('id'), evt);
			evt.preventDefault();
		});
	});
}

function ABAGhelp(id, evt) {
	var modal = document.getElementById(id + '-content'); // nicht global
	modal.style.display = 'block';
	modal.addEventListener('click', closeModal);
	modal.modal = modal; // Parameteruebergabe
}

function closeModal(evt) {
	//if (evt.target == modal) {
	if (evt.target == evt.target.modal) {
		//modal.style.display = "none";
		evt.target.modal.style.display = 'none';
		document.removeEventListener('click', closeModal);
	}
}

function closeHelp(evt) {
	evt.parentNode.parentNode.parentNode.style.display = 'none';
	document.removeEventListener('click', closeModal);
}

//************************************************
// * Home
//************************************************

// ----------------------------
// * Home Laden
// ----------------------------

function inithome(val) {
	loadhome(val);
}

function loadhome(val) {
	displayFaktorMethode(val);
}

//************************************************
// * Print
//************************************************

// ----------------------------
// * print-Initialisieren und Laden
// ----------------------------

function initprint(val) {
	/*
    loadData(_folder + "aerosionsgefaehrdung.json", "", function(data) {
        loadprint(val, data);
    });
	*/
	loadprint(val);
}

function printFaktor(faktor, arr) {
	var tab = 90;
	if (typeof _rPrintTexte[faktor].Methods != 'undefined') {
		for (var i = 0; i < _rPrintTexte[faktor].Methods.length; i++) {
			var method = _rPrintTexte[faktor].Methods[i];

			var text;
			if (typeof method.Title != 'undefined') {
				text = method.Title;
				text = text.replace('</sub>', '');
				text = text.replace('<sub>', '');
				arr.push('\t' + text);
			}

			if (method.Para.length > 0) {
				arr.push('\tBerechnung nach: ' + method.Method);
				arr.push('\tEingesetzte Parameter:');
				for (var rec in method.Para) {
					if (method.Para[rec].Text.length > 23) tab = 140;
				}
				
				
				for (rec in method.Para) {
					var val = method.Para[rec].Value;
					
					// Leerzeile:
					if (method.Para[rec].Text.toString().length == 0 && val.length == 0) {
						arr.push('\t' + "");
					} else {
						// geht nicht so nicht:
						//if (!isNaN(parseFloat(val)) && val.toString().lastIndexOf('.') > 0) val = Number(method.Para[rec].Value).toFixed(2);
						if (method.Para[rec].Text == 'Anbausystem') {
							text = method.Para[rec].Text + ' :#90#' + method.Para[rec].Value;
						} else {
							if (tab == 90) {
								text = method.Para[rec].Text + ' :#' + tab + '#' + val;
							} else {
								text = method.Para[rec].Text + ' : ' + val;
							}
						}
						text = text.replace('</sub>', '');
						text = text.replace('<sub>', '');
						arr.push('\t\t' + text);
					}
					
					//console.log(text);
				}
			}
		}
	}
}
 

function loadprint(val, data) {
	var gText = [];

	var t = [];
	var today = new Date();
	var dd = today.getDate();
	var mm = today.getMonth() + 1; //January is 0!
	var value = '';

	if (dd < 10) {
		dd = '0' + dd;
	}
	if (mm < 10) {
		mm = '0' + mm;
	}
	t.push('#170#' + dd + '.' + mm + '.' + today.getFullYear());

	if (document.getElementById('beratung').value.length > 0 || document.getElementById('bearbeiter').value.length > 0 || document.getElementById('schlag').value.length > 0 || document.getElementById('bemerkungen').value.length > 0) {
		t.push('bold|Informationen zum Schlag');
		t.push('\tBeratung für:#70#' + document.getElementById('beratung').value);
		t.push('\tBearbeiter:#70#' + document.getElementById('bearbeiter').value);
		t.push('\tSchlag:#70#' + document.getElementById('schlag').value);
		t.push('\tBemerkungen:');
		t.push('\t\t' + document.getElementById('bemerkungen').value);
	}
	gText.push(t);

	t = [];
	//t.push("bold|Tatsächlicher Bodenabtrag [t/(ha*a)]: " + getAFaktor(data)); // Keine Kategorisierung nach DIN
	t.push('bold|Berechneter Bodenabtrag [t/(ha*a)]: ' + getAFaktor(data));
	gText.push(t);

	t = [];
	value = getFaktorValue('T');
	t.push('bold|Toleranzgrenze Bodenabtrag [t/(ha*a)]: ' + Number(value).toFixed(1));
	gText.push(t);

	t = [];
	value = getFaktorValue('R', true);
	//t.push("bold|Regen (R-Faktor)#150#Geschätzter Wert: " + Number(value).toFixed(0));
	t.push('bold|Regen (R-Faktor)#150#Berechneter Wert: ' + value);
	printFaktor('R', t);
	gText.push(t);

	t = [];
	value = getFaktorValue('K', true);
	//t.push("bold|Boden (K-Faktor)#150#Geschätzter Wert: " + Number(value).toFixed(2));
	t.push('bold|Boden (K-Faktor)#150#Berechneter Wert: ' + value);
	printFaktor('K', t);
	gText.push(t);

	t = [];
	value = getFaktorValue('LS', true);
	//t.push("bold|Hangform (LS-Faktor)#150#Geschätzter Wert: " + Number(value).toFixed(2));
	t.push('bold|Hangform (LS-Faktor)#150#Berechneter Wert: ' + value);
	printFaktor('LS', t);
	gText.push(t);

	t = [];
	value = getFaktorValue('C', true);
	//t.push("bold|Bewirtschaftung (C-Faktor)#150#Geschätzter Wert: " + Number(value).toFixed(2));
	t.push('bold|Bewirtschaftung (C-Faktor)#150#Berechneter Wert: ' + value);
	printFaktor('C', t);
	gText.push(t);

	t = [];
	value = getFaktorValue('P', true);
	//t.push("bold|Bearbeitungsrichtung (P-Faktor)#150#Geschätzter Wert: " + Number(value).toFixed(2));
	t.push('bold|Bearbeitungsrichtung (P-Faktor)#150#Berechneter Wert: ' + value);
	printFaktor('P', t);
	gText.push(t);

	createPDF('abaginteraktiv.pdf', gText);
}

function createPDF(filename, gText) {
	// We'll make our own renderer to skip this editor
	//        'elementHandlers': specialElementHandlers

	//#am NRW
	//const { jsPDF } = window.jspdf;
	//var pdf = new jsPDF('p', 'mm', 'a4');
	var pdf = new window.jspdf.jsPDF('p', 'mm', 'a4');
	var pageHeight = pdf.internal.pageSize.height;
	//#am NRW
	//pdf.setFontType('normal');
	pdf.setFont('helvetica', 'normal');
	pdf.setFontSize('11');

	pdf.text('Bodenerosion - Ermittlung des Bodenabtrags nach ABAG interaktiv', 30, 30);
	var imgData =
		'data:image/png;base64,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';
	pdf.addImage(imgData, 'JPEG', 10, 20, 15, 15);

	var y = 50;
	var style = 'normal',
		sText = '',
		tmp;
	gText.forEach(function (text) {
		var splitTitle = pdf.splitTextToSize(text, 270);
		for (var i = 0; i < splitTitle.length; i++) {
			if (y > pageHeight - 60) {
				y = 30;
				pdf.addPage();
			}

			style = 'normal';
			tmp = splitTitle[i].split('|');
			if (tmp.length == 2) {
				style = tmp[0];
				sText = tmp[1];
			} else {
				sText = tmp[0];
			}
			//#am NRW
			//pdf.setFontStyle(style);
			pdf.setFont('helvetica', style);
			if (sText.split('#').length > 1) {
				tmp = sText.split('#');
				pdf.text(30, y, tmp[0]);
				pdf.text(parseInt(tmp[1]), y, tmp[2]);
			} else {
				pdf.text(30, y, sText);
			}
			y += 7;
		}
		y += 5;
	});
	pdf.save(filename);
}

//************************************************
// * Nutzungsbedingungen
//************************************************
function initnutzbed(val) {
	loadnutzbed(val);
}

function loadnutzbed(val) {
	displayFaktorMethode(val);
}

//************************************************
// * Info
//************************************************

// ----------------------------
// * Info-Initialisieren und Laden
// ----------------------------

function initinfo(val) {
	loadinfo(val);
}

function loadinfo(val) {
	displayFaktorMethode(val);
}

//************************************************
// * A Ergebnis
//************************************************

// ----------------------------
// * A-Initialisieren und Laden
// ----------------------------

function initA(val) {
	loadA(val);
	initInputRange(document.getElementById('section-A').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	initABAGhelp(document.getElementById('section-A').getElementsByClassName('helpbutton'));
	initABAGhelp([document.getElementById('hilfe-A')]);
}

function loadA(val) {
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...
	displayFaktorMethode(val);
	// Anzeigen der Ergebnisse
	setAFaktor();
	// Anzeigen der Details
	loadDetail('R');
	loadDetail('K');
	loadDetail('LS');
	loadDetail('C');
	loadDetail('P');
}

// --------------------------
// * A-Auswerten
// --------------------------

function setAFaktor() {
	/* Keine DIN-Einordnung mehr
    loadData(_folder + "aerosionsgefaehrdung.json", "", function(data) {
        var a = getAFaktor(data);
        fillValuesInPage("A", a);
    });
	*/

	var a = getAFaktor();
	fillValuesInPage('A', a);

	//document.getElementById(id + "-faktor").value;
	var toleranz = calcAToleranz(document.getElementById('A-bodenzahl').value);
	fillValuesInPage('T', toleranz);
}

function getAFaktor(data) {
	// Berechnung des Ergebnisses
	var rfaktor = getFaktorValue('R');
	document.getElementById('Rfaktor').innerHTML = rfaktor;

	var kfaktor = getFaktorValue('K');
	document.getElementById('Kfaktor').innerHTML = kfaktor;

	var lsfaktor = getFaktorValue('LS');
	document.getElementById('LSfaktor').innerHTML = lsfaktor;

	var cfaktor = getFaktorValue('C');
	document.getElementById('Cfaktor').innerHTML = cfaktor;

	var pfaktor = getFaktorValue('P');
	document.getElementById('Pfaktor').innerHTML = pfaktor;

	//xxx mit was wird gerechnet, hier ueberall nur 2 Stellen hinter dem Komma
	var a = parseFloat(rfaktor) * parseFloat(kfaktor) * parseFloat(lsfaktor) * parseFloat(cfaktor) * parseFloat(pfaktor);

	//console.log(isNaN(a))
	if (isNaN(a) == true) {
		a = '';
	} else {
		a = a.toFixed(1);
	}

	/* Keine DIN-Einordnung mehr
    for (var rec in data) {
        if (a < parseFloat(data[rec])) {
            a += " ( " + rec + " )";
            break;
        }
    }
	*/

	return a;
}

function getFaktorValue(faktor, print) {
	var ele = document.getElementById('txt-' + faktor);

	if (ele != null) return ele.innerHTML;

	if (typeof print == 'undefined') return 'Parameter noch nicht gesetzt';
	return '';
}

function loadDetail(faktor) {
	var value = getFaktorValue(faktor);
	txt = '<p>Geschätzter ' + faktor + "-Faktor:<span class='anzeigetxt'>" + value + '</span></p>';

	ele = document.getElementById('detail-' + faktor);
	ele.innerHTML = txt;

	if (typeof _rPrintTexte[faktor].Methods == 'undefined') return;

	//if (_rPrintTexte[faktor].Methods.length == 0) return;

	// Methoden
	//console.log(_rPrintTexte[faktor]);

	for (var i = 0; i < _rPrintTexte[faktor].Methods.length; i++) {
		var method = _rPrintTexte[faktor].Methods[i];

		if (typeof method.Title != 'undefined') {
			txt += '<p><strong>' + method.Title + '</strong></p>';
		}

		if (method.Para.length > 0) {
			txt += "<p>Berechnung nach: <span class='anzeigetxt'>" + method.Method + '</span></p>';
			txt += "<p>Eingesetzte Parameter:</p><p class='anzeigetxt'>";
			for (var rec in method.Para) {
				//console.log(_rPrintTexte[faktor].Para[rec].Text + " : " + _rPrintTexte[faktor].Para[rec].Value)
				
				if (method.Para[rec].Text.toString().length == 0 && method.Para[rec].Value.toString().length == 0) {
					txt += '<br>';
				} else {
					var val = method.Para[rec].Value;
					// xxx Achtung, wieder aendern: Kuerzt letzte Stelle, noetig
					// geht so nicht, z.B. Fehler bei Oberflächenrauhigkeit 2.5-7.5
					//if (!isNaN(parseFloat(val)) && val.toString().lastIndexOf('.') > 0) val = Number(method.Para[rec].Value).toFixed(2);
					txt += method.Para[rec].Text + " : <span class='anzeigetxt'>" + val + '</span><br>';
				}
			}
			txt += '</p>';
		}
		ele.innerHTML = txt;
	}
}
function calcAToleranz(bodenzahl) {
	var value = parseInt(bodenzahl) / 8;
	value = value.toFixed(1);

	return value;
}

//************************************************
// * R Regen
//************************************************

// ----------------------------
// * R-Initialisieren und Laden
// ----------------------------

function initR(val) {
	// Daten laden

	// Zuweisung von Events
	// Radio-Button
	var arr = Array.prototype.slice.call(document.getElementsByClassName('RRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			loadR(this.getAttribute('id'));
		});
	});
	document.getElementById('R-gemeinden-bundesland').addEventListener('change', function () {
		var bl = getValueFromSelected(this);
		_setBundesland(bl);
		/*
		const lsMapDisp = document.getElementById('LS-map');
		const kMapDisp = document.getElementById('K-map');
		const lsSectionMapDisp = document.getElementById('section-LS-map');
		const kSectionMapDisp = document.getElementById('section-K-map');

		if (hasMap) {
			console.log("ein");
			document.getElementById('nav-links-offline').classList.remove('hidden');
			document.getElementById('nav-collapsible-links-LS-map').classList.remove('hidden');
			document.getElementById('nav-collapsible-links-K-map').classList.remove('hidden');
			if (lsMapDisp) {
				lsMapDisp.classList.remove('hidden');
				lsMapDisp.click();
			}
			if (kMapDisp) {
				kMapDisp.classList.remove('hidden');
				kMapDisp.click();
			}
		} else {
			console.log("aus");
			document.getElementById('nav-links-offline').classList.add('hidden');
			document.getElementById('nav-collapsible-links-LS-map').classList.add('hidden');
			document.getElementById('nav-collapsible-links-K-map').classList.add('hidden');
			if (lsMapDisp) lsMapDisp.classList.add('hidden');
			if (lsSectionMapDisp) lsSectionMapDisp.classList.add('hidden');
			if (kMapDisp) kMapDisp.classList.add('hidden');
			if (kSectionMapDisp) kSectionMapDisp.classList.add('hidden');

			document.getElementById('LS-eingabe').click();
			document.getElementById('K-analyse').click();
		}
		console.log(lsMapDisp.classList);
		console.log(kMapDisp.classList);
		document.getElementById('R').click();
		*/
		loadRLandkreise(bl);
		setRFaktor(this.getAttribute('id'));
	});
	document.getElementById('R-gemeinden-landkreis').addEventListener('change', function () {
		loadRGemeinden(getValueFromSelected('R-gemeinden-bundesland'), getValueFromSelected(this));
		setRFaktor(this.getAttribute('id'));
	});
	document.getElementById('R-gemeinden-gemeinde').addEventListener('change', function () {
		var gemeinde = _rfaktorGemeinden[getValueFromSelected('R-gemeinden-bundesland')][getValueFromSelected('R-gemeinden-landkreis')][getTextFromSelected(this)];
		console.log(gemeinde);
		loadRGemeinde(gemeinde);
		setRFaktor(this.getAttribute('id'));
	});

	initInputRange(document.getElementById('section-R').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);

	initABAGhelp(document.getElementById('section-R').getElementsByClassName('helpbutton'));
	//makeSticky(document.getElementById("section-R").getElementsByClassName('sticky'));
	if (L.Browser.ie) {
		document.getElementById('rfaktorimgSVG').classList.add('rfaktorimgSVG');
	}

	loadR(val);
}

function loadR(val) {
	console.log("loadR: " + val);
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...
	var methode;
	// Wenn ueber runde Buttons nur Laden des Faktors
	var faktor = getFaktor(val);
	if (getMethode(val) == null) {
		methode = getSelectedMethodeFromRad(faktor + 'Rad');
		val = faktor + '-' + methode;
	}
	displayFaktorMethode(val);

	methode = getMethode(val);
	if (methode == 'gemeinden') {
		if (_rfaktorGemeinden == null) {
			loadData(_folder + 'rfaktorgemeinden.json', 'R-gemeinden', insertDataR);
		} else {
			var ele = document.getElementById('R-gemeinden-bundesland');
			if (getValueFromSelected(ele) == null) {
				loadRBundeslaender(ele, val);
			} else {
				setRFaktor(val);
			}
		}
	} else {
		setRFaktor(val);
	}
}

function insertDataR(data, id) {
	_rfaktorGemeinden = data;
	var ele = document.getElementById('R-gemeinden-bundesland');
	if (ele == null) return;
	//Fuellen der Bundeslandliste
	loadRBundeslaender(ele, id);
}

function loadRBundeslaender(ele, id) {
	var txts = '';
	for (var rec in _rfaktorGemeinden) {
		txts += '<option value="' + rec + '">' + rec + '</option>';
	}
	ele.innerHTML = txts;

	//Bundesland vorbelegen
	ele.value = localStorage.getItem('bl');

	loadRLandkreise(getValueFromSelected(ele));
	// Wenn vorher Bayern ueber Karte gewaehlt wurde auswerten des nominatims
	//console.log(_rLKRGem);
	if (_rLKRGem != null) {
		var display_name = _rLKRGem.display_name;
		if (display_name.indexOf('Landkreis') !== -1) {
			var landkreis = display_name.substring(display_name.indexOf('Landkreis') + 9);
			landkreis = landkreis.substring(0, landkreis.indexOf(',')).trim();
			// Gemeinde steht vor dem Landkreis
			var gemeinde = display_name.substring(0, display_name.indexOf('Landkreis'));
			gemeinde = gemeinde.substring(0, gemeinde.lastIndexOf(','));
			gemeinde = gemeinde.substring(gemeinde.lastIndexOf(',') + 1).trim();
			var lkrele = document.getElementById('R-gemeinden-landkreis');
			console.log('nominatim liefert' + landkreis + ' : ' + gemeinde);
			for (var i in lkrele.options) {
				if (lkrele.options[i].text == landkreis) {
					console.log('Nutzer befindet sich in ' + landkreis);
					lkrele.selectedIndex = i;
					loadRGemeinden(getValueFromSelected('R-gemeinden-bundesland'), landkreis); // Bayern ist schon gewaehlt
					var gemele = document.getElementById('R-gemeinden-gemeinde');
					for (var j in gemele.options) {
						// unzureichend, da Gemeinde nicht klar von nominatim kommt, besser ware postalcode
						if (gemele.options[j].text == gemeinde) {
							console.log('Nutzer befindet sich in Gemeinde ' + gemeinde);
							gemele.selectedIndex = j;
							break;
						}
					}
					break;
				}
			}
		}
	}
	setRFaktor(id);
}

function loadRLandkreise(bundesland) {
	//gespeicherte Tiles zurücksetzen, wenn Bundesland geändert
	_eleTiles = []

	console.log(bundesland);
	var txts = '';
	var landkreise = _rfaktorGemeinden[bundesland];
	for (var rec in landkreise) {
		txts += '<option value="' + rec + '">' + rec + '</option>';
	}
	var ele = document.getElementById('R-gemeinden-landkreis');
	ele.innerHTML = txts;
	loadRGemeinden(bundesland, getValueFromSelected(ele));
}

function loadRGemeinden(bundesland, landkreis) {
	var txts = '';
	var gemeinden = _rfaktorGemeinden[bundesland][landkreis];
	var gemeinde;
	for (var rec in gemeinden) {
		gemeinde = gemeinden[rec];
		txts += '<option value="' + gemeinde.RFaktor + '">' + rec + '</option>';
	}
	var ele = document.getElementById('R-gemeinden-gemeinde');
	ele.innerHTML = txts;
	loadRGemeinde(gemeinde);
}

function loadRGemeinde(gemeinde) {
	//Position der Gemeinde merken
	_rPosition = [gemeinde.Loc[0], gemeinde.Loc[1]];
	// Gesamtdeutschland
	// SVG
	var imgHeight = 474; // 47.3695 = suedlichster Wert; 55.0251 = Differenz 7.6286 // Zipfelbund
	var yDif = 55.0251 - 47.3695;
	var imgWidth = 344; // 5.92212 = westlicher Wert
	var xDif = 14.9684 - 5.92212;
	var posY = (imgHeight * (55.0251 - gemeinde.Loc[0])) / yDif;
	var posX = (imgWidth * (gemeinde.Loc[1] - 5.92212)) / xDif;
	var circleEle = document.getElementById('R-gemeinden-gemeindecirle');
	circleEle.setAttribute('cx', posX);
	circleEle.setAttribute('cy', posY);
}

// --------------------------
// * R-Auswerten
// --------------------------

function setRFaktor(val) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);

	var rfaktor = 0;
	var text = '';
	var id = faktor + '-' + methode; //

	var printObj = {};
	printObj.Method = document.getElementById(id).innerHTML; // Radio-Button-Text
	printObj.Para = [];
	_rPrintTexte.R.Methods = [];
	_rPrintTexte.R.Methods.push(printObj);

	switch (methode) {
		case 'faktor':
			rfaktor = document.getElementById(id + '-faktor').value;
			console.log(rfaktor);
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, rfaktor);
			break;

		case 'gemeinden':
			ele = document.getElementById(id + '-gemeinde');
			text = getLabelTextFromFormEle(id + '-gemeinde');
			storeToPrint(printObj, text, getTextFromSelected(ele));
			rfaktor = parseFloat(getValueFromSelected(ele)); //.toFixed(0);
			//Korrektur des R-Faktor e-mail vom 17.12.19 Frau Treisch
			rfaktor = (rfaktor * 1.27).toFixed(0);
			break;
	}
	fillValuesInPage(faktor, rfaktor);
}

//************************************************
// * K Boden
//************************************************

// ----------------------------
// * K-Initialisieren und Laden
// ----------------------------

function initK(val) {
	// Zuweisung von Events
	// Radio-Button
	var arr = Array.prototype.slice.call(document.getElementsByClassName('KRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			loadK(this.getAttribute('id'));
		});
	});

	arr = Array.prototype.slice.call(document.getElementsByClassName('KsteinbedeckungRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			//scrollToSection(this);
			loadKSteinbedeckung(this.getAttribute('id'));
		});
	});

	arr = Array.prototype.slice.call(document.getElementsByClassName('KfeinbodenRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			//scrollToSection(this);
			loadKFeinboden(this.getAttribute('id'));
		});
	});

	document.getElementById('K-analyse-steinbedeckung-schaetzung-beschrieb').addEventListener('change', function () {
		loadKAnalyseSchaetzungBodenart(_ksteinbedeckungschaetzungTab, getValueFromSelected(this), 'K-analyse-steinbedeckung-schaetzung');
		setKFaktor(this.getAttribute('id'));
	});
	document.getElementById('K-analyse-steinbedeckung-schaetzung-bodenart').addEventListener('change', function () {
		var id = 'K-analyse-steinbedeckung-schaetzung';
		loadKAnalyseSchaetzungZustandsstufe(_ksteinbedeckungschaetzungTab, getValueFromSelected(id + '-beschrieb'), getValueFromSelected(this), id);
		setKFaktor(this.getAttribute('id'));
	});
	document.getElementById('K-analyse-steinbedeckung-schaetzung-zustandsstufe').addEventListener('change', function () {
		setKFaktor(this.getAttribute('id'));
	});

	document.getElementById('K-analyse-feinboden-schaetzung-beschrieb').addEventListener('change', function () {
		loadKAnalyseSchaetzungBodenart(_kfeinbodenschaetzungTab, getValueFromSelected(this), 'K-analyse-feinboden-schaetzung');
		setKFaktor(this.getAttribute('id'));
	});
	document.getElementById('K-analyse-feinboden-schaetzung-bodenart').addEventListener('change', function () {
		var id = 'K-analyse-feinboden-schaetzung';
		loadKAnalyseSchaetzungZustandsstufe(_kfeinbodenschaetzungTab, getValueFromSelected(id + '-beschrieb'), getValueFromSelected(this), id);
		setKFaktor(this.getAttribute('id'));
	});
	document.getElementById('K-analyse-feinboden-schaetzung-zustandsstufe').addEventListener('change', function () {
		setKFaktor(this.getAttribute('id'));
	});

	document.getElementById('K-analyse-feinboden-texturanalyse-bodenart').addEventListener('change', function () {
		loadKAnalyseFeinbodenTexturanalyse(getValueFromSelected(this), this.getAttribute('id'));
	});

	document.getElementById('K-analyse-feinboden-texturanalyse-sandboden').addEventListener('change', function () {
		setKFaktor(this.getAttribute('id'));
	});

	arr = Array.prototype.slice.call(document.getElementById('section-K-analyse-feinboden-bodenanalyse').getElementsByTagName('input'));
	arr.forEach(function (ele) {
		if (ele.type == 'range') {
			ele.addEventListener('mousemove', function () {
				setSlidersMax100Prozent(this, 'section-K-analyse-feinboden-bodenanalyse');
			});
			ele.addEventListener('touchmove', function () {
				setSlidersMax100Prozent(this, 'section-K-analyse-feinboden-bodenanalyse');
			});
		}
	});

	document.getElementById('K-analyse-feinboden-bodenanalyse-aggregatklasse').addEventListener('change', function () {
		setKFaktor(this.getAttribute('id'));
	});

	document.getElementById('K-analyse-feinboden-bodenanalyse-durchlaessigkeitsklasse').addEventListener('change', function () {
		setKFaktor(this.getAttribute('id'));
	});

	initInputRange(document.getElementById('section-K-analyse-steinbedeckung-messung').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	initInputRange(document.getElementById('section-K-analyse-feinboden-bodenanalyse').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	initInputRange(document.getElementById('section-K-faktor').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);

	initInputRange(document.getElementById('section-K-analyse-feinboden-texturanalyse-andererboden').getElementsByClassName('bodenartdiagramm'), sliderBodendiagrammChange, sliderBodendiagrammStop, sliderBodendiagrammtxtChange);

	initABAGhelp(document.getElementById('section-K').getElementsByClassName('helpbutton'));

	if (L.Browser.ie) {
		document.getElementById('bodendiagrammSVG').classList.add('bodendiagrammSVG');
	}

	// Hier Beginn asynchrones Laden von verschiedenen Dokumenten, die ggf. auch an mehreren Stellen benoetigt werden
	loadData(_folder + 'kdurchlaessigkeitsklassen.json', 'K-analyse-feinboden-bodenanalyse-durchlaessigkeitsklasse', insertDataK1, 2, val);
}

function insertDataK1(data, id, selectedIndex, val) {
	insertData(data, id, selectedIndex); // Durchlaessigkeitsklassen
	loadData(_folder + 'kaggregatklassen.json', 'K-analyse-feinboden-bodenanalyse-aggregatklasse', insertDataK2, 2, val);
}

function insertDataK2(data, id, selectedIndex, val) {
	insertData(data, id, selectedIndex); // Aggregatsklassen
	loadData(_folder + 'kfeinbodensandboden.json', 'K-analyse-feinboden-texturanalyse-sandboden', insertDataK3, 4, val);
}

function insertDataK3(data, id, selectedIndex, val) {
	insertData(data, id, selectedIndex); // KFeinboden reiner Sand
	loadData(_folder + 'kbodenart.json', '', insertDataK4, -1, val);
}

function insertDataK4(data, id, selectedIndex, val) {
	_kbodenartTab = data;
	loadData(_folder + 'kzustandsstufe.json', '', insertDataK5, -1, val);
}

function insertDataK5(data, id, selectedIndex, val) {
	_kzustandsstufeTab = data;
	loadK(val);
}

function loadK(val) {
	console.log("loadK: " + val)
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...
	var mapRadButton = document.getElementById('K-map');
	if (!hasMap) {
		mapRadButton.classList.add('hidden');
		// LS-eingabe ist die voreingestellt Auswahl
		var ele = document.getElementById('K-analyse');
		/*
		ele.classList.add('radchecked');
		ele.classList.add('bg--dark--' + val);
		ele.classList.remove('radunchecked');
		ele.classList.remove('bg--' + val);
		*/
		ele.click();
	} else {
		// Nur einmal machen, ansonsten kommt man immer wieder zur Karte mit click(), ggf. will man das ja gar nicht mehr
		if (mapRadButton.classList.contains('hidden')) {
			mapRadButton.classList.remove('hidden');
			mapRadButton.click();
		}
	}


	var faktor = getFaktor(val);
	var methode;
	//kein automatisches Fullmap bei Mobile gewünscht
	var fullMap = false; //true;

	if (getMethode(val) == null) {
		// Wenn ueber runde Buttons nur Laden des Faktors
		console.log('Aufruf über runder Button');
		methode = getSelectedMethodeFromRad(faktor + 'Rad');
		val = faktor + '-' + methode;
	}
	displayFaktorMethode(val);

	// Wenn Methode analyse und erster Aufruf, laden der Dateien
	methode = getMethode(val);

	// #am NRW
	switch (methode) {
		case 'map':
			//Wenn Karte erlaubt (Bayern, NRW) dann starten
			initMap(fullMap, 'k');
			setKFaktor(val);
			break;
		case 'analyse':
			// Snackbar von der Karte entfernen (Angabe stoert sonst)
			Snackbar.close();

			// Hier Aufspaltung in Steinbedeckung und Feinboden, was ist gewaehlt
			loadKAnalyse(val);
			break;
		default:
			// Snackbar von der Karte entfernen (Angabe stoert sonst)
			Snackbar.close();

			setKFaktor(val); // Direkte Faktoreneingabe
	}

	/*	
	if (methode == 'analyse') {
		// Hier Aufspaltung in Steinbedeckung und Feinboden, was ist gewaehlt
		loadKAnalyse(val);
	} else {
		setKFaktor(val); // Direkte Faktoreneingabe
	}
	*/
}

function loadKAnalyse(val) {
	// hier zwei Untermethoden: Steinbedeckung und Feinboden
	loadKSteinbedeckung(val);
	loadKFeinboden(val);
}

function loadKSteinbedeckung(val) {
	var subMethode = getSubMethode(val); // Messung oder Bodenschaetzung
	if (subMethode == null) {
		subMethode = getSelectedSubMethodeFromRad('KsteinbedeckungRad');
		val = val + '-steinbedeckung-' + subMethode;
	}
	displayRadFaktorMethode('K', subMethode, 'KsteinbedeckungRad');
	displayKanalyse(val);

	// Was muss noch geladen werden,
	// bei Messung nichts
	if (subMethode == 'schaetzung' && _ksteinbedeckungschaetzungTab == null) {
		loadData(_folder + 'ksteinbedeckungschaetzung.json', val, insertDataKSteinbedeckungSchaetzung);
	} else {
		//console.log("asdf " + subMethode);
		setKFaktor(val);
	}
}

function insertDataKSteinbedeckungSchaetzung(data, id) {
	_ksteinbedeckungschaetzungTab = data;
	loadKAnalyseSchaetzungBodenart(_ksteinbedeckungschaetzungTab, getValueFromSelected(id + '-beschrieb'), id);
	setKFaktor(id);
}

function loadKAnalyseSchaetzungBodenart(tab, beschrieb, id, bodenart) {
	var txts = '';
	var ele = document.getElementById(id + '-bodenart');
	ele.removeAttribute('disabled');
	var selectedIndex = 0;
	var zustandsstufe = null;
	for (var rec in tab) {
		if (rec == beschrieb) {
			for (var i = 0, len = tab[rec].length; i < len; i++) {
				txts += '<option value="' + tab[rec][i].bodenart + '">' + _kbodenartTab[tab[rec][i].bodenart] + '</option>';
				// nur einmalig, wenn feinboden geladen wird und Schaetzung schon ausgefuellt worden ist
				if (typeof bodenart != 'undefined' && _kbodenartTab[tab[rec][i].bodenart] == bodenart) {
					//console.log(_kbodenartTab[tab[rec][i].bodenart] + " : " + bodenart);
					selectedIndex = i;
					zustandsstufe = getTextFromSelected('K-analyse-steinbedeckung-schaetzung-zustandsstufe');
				}
			}
			if (tab[rec].length == 1) ele.setAttribute('disabled', 'disabled');
			break;
		}
	}
	ele.innerHTML = txts;
	ele.selectedIndex = selectedIndex;
	loadKAnalyseSchaetzungZustandsstufe(tab, beschrieb, getValueFromSelected(ele), id, zustandsstufe);
}

function loadKAnalyseSchaetzungZustandsstufe(tab, beschrieb, bodenart, id, zustandsstufe) {
	var txts = '';
	var ele = document.getElementById(id + '-zustandsstufe');
	ele.removeAttribute('disabled');
	var selectedIndex = 0;
	for (var i = 0, len = tab[beschrieb].length; i < len; i++) {
		if (tab[beschrieb][i].bodenart == bodenart) {
			var zustandsstufen = tab[beschrieb][i].zustandsstufe;
			var index = 0;
			for (var rec in zustandsstufen) {
				txts += '<option value="' + zustandsstufen[rec] + '">' + _kzustandsstufeTab[rec] + '</option>';

				// nur einmalig, wenn feinboden geladen wird und Schaetzung schon ausgefuellt worden ist
				if (typeof zustandsstufe != 'undefined' && _kzustandsstufeTab[rec] == zustandsstufe) {
					//console.log(_kbodenartTab[tab[rec][i].bodenart] + " : " + bodenart);
					selectedIndex = index;
				}
				index++;
			}
			if (index == 1) ele.setAttribute('disabled', 'disabled');
			break;
		}
	}
	ele.innerHTML = txts;
	ele.selectedIndex = selectedIndex;
}

function loadKAnalyseFeinbodenTexturanalyse(bodenart, id) {
	// An und ausschalten der Sektionen der Faktoren
	var arr = Array.prototype.slice.call(document.getElementsByClassName('section-K-analyse-feinboden-texturanalyse'));
	arr.forEach(function (ele) {
		if (ele.getAttribute('id').indexOf(bodenart) !== -1) {
			ele.classList.remove('hidden');
		} else {
			ele.classList.add('hidden');
		}
	});

	if (bodenart == 'andererboden' && _kfeinbodenandererbodenTab == null) {
		loadData(_folder + 'kfeinbodenandererboden.json', id, insertDataKFeinbodenTexturanalyseAndererboden);
	} else {
		setKFaktor(id);
	}
}

function insertDataKFeinbodenTexturanalyseAndererboden(data, id) {
	_kfeinbodenandererbodenTab = data;
	sliderBodendiagrammChange('ton');
}

function loadKFeinboden(val) {
	var subMethode = getSubMethode(val);
	if (subMethode == null) {
		subMethode = getSelectedSubMethodeFromRad('KfeinbodenRad');
		val = val + '-feinboden-' + subMethode;
	}

	displayRadFaktorMethode('K', subMethode, 'KfeinbodenRad');
	displayKanalyse(val);

	// Was muss noch geladen werden,
	// bei Messung nichts
	switch (subMethode) {
		case 'schaetzung':
			if (_kfeinbodenschaetzungTab == null) {
				loadData(_folder + 'kfeinbodenschaetzung.json', val, insertDataKFeinbodenSchaetzung);
			} else {
				setKFaktor(val);
			}
			break;
		case 'texturanalyse':
			loadKAnalyseFeinbodenTexturanalyse(getValueFromSelected(val + '-bodenart'), val);
			break;
		default:
			setKFaktor(val);
			break;
	}
}

function insertDataKFeinbodenSchaetzung(data, id) {
	_kfeinbodenschaetzungTab = data;
	var bodenart = null;
	// Wenn _ksteinbedeckungschaetzungTab schon geladen ist, hier einmalig die Einstellungen uebernehmen
	if (_ksteinbedeckungschaetzungTab != null) {
		var beschriebObj = document.getElementById(id + '-beschrieb'); //K-analyse-feinboden-schaetzung-beschrieb
		var steinbedeckungBeschrieb = getValueFromSelected('K-analyse-steinbedeckung-schaetzung-beschrieb');
		// gibt es diesen beschrieb bei Feinboden auch?
		for (var i = 0; i < beschriebObj.options.length; i++) {
			if (beschriebObj.options[i].value == steinbedeckungBeschrieb) {
				//beschriebObj.value = steinbedeckungBeschrieb;
				beschriebObj.selectedIndex = i;
				bodenart = getTextFromSelected('K-analyse-steinbedeckung-schaetzung-bodenart');
				break;
			}
		}
	}
	loadKAnalyseSchaetzungBodenart(_kfeinbodenschaetzungTab, getValueFromSelected(id + '-beschrieb'), id, bodenart);
	setKFaktor(id);
}

function displayKanalyse(val) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);
	var subMethode = getSubMethode(val);
	var subFaktor = val.split('-')[2]; // hier steinbedeckung oder feinboden..

	// An und ausschalten der Unterpunkte
	var arr = Array.prototype.slice.call(document.getElementsByClassName('section-' + faktor + '-' + methode + '-' + subFaktor));
	arr.forEach(function (ele) {
		if (ele.getAttribute('id').indexOf(subMethode) !== -1) {
			ele.classList.remove('hidden');
		} else {
			ele.classList.add('hidden');
		}
	});
}

// --------------------------
// * K-Bodendiagramm-Bild
// --------------------------
function sliderBodendiagrammStop(e) {
	e.target.removeEventListener('mousemove', sliderBodendiagrammChange);
	e.target.removeEventListener('mouseup', sliderBodendiagrammStop);
}

function sliderBodendiagrammtxtChange(e) {
	var value = e.target.value;
	// Es ist gerade ein Punkt eingegeben worden
	if (value.indexOf('.') == value.length - 1) return;
	if (isNaN(value)) value = 0;
	var sliderId = e.target.id.substr(e.target.id.indexOf('slidertxt-') + 10);
	var sliderEle = document.getElementById(sliderId);
	var maxVal = parseInt(sliderEle.getAttribute('max'));
	value = value > maxVal ? maxVal : value;

	sliderEle.value = value;
	e.target.value = value;
	var aktSlider = sliderEle.id.substring(sliderEle.id.lastIndexOf('-') + 1);
	sliderBodendiagrammChange(aktSlider);
}

function sliderBodendiagrammChange(aktSlider) {
	if (typeof aktSlider != 'string') {
		// aktSlider ist hier dann der event
		aktSlider = aktSlider.target.id.substring(aktSlider.target.id.lastIndexOf('-') + 1);
	}

	var id = 'K-analyse-feinboden-texturanalyse-andererboden';
	var sliderTon = document.getElementById(id + '-ton');
	var sliderSchluff = document.getElementById(id + '-schluff');

	// Momentane Werte
	var valueTon = parseInt(sliderTon.value);
	var valueSchluff = parseInt(sliderSchluff.value);

	calcKFeinbodenTexturanalyseAndererboden(valueTon, valueSchluff, aktSlider, sliderTon, sliderSchluff);
}

function circleBodendiagrammStart(evt) {
	evt.preventDefault();

	// Pixel-Werte vom Bodenartendreieck
	// Bei Originalgroesse gelten folgende Werte
	var width = 411;
	var height = 398;
	var rect = document.getElementById('bodendiagrammSVG').getBoundingClientRect();
	_picFaktor = rect.width / width;

	//evt.target.setAttribute("pointer-events","none");
	var eType = 'mousemove';
	if (evt.clientX) {
		circleStartX = evt.clientX / _picFaktor - evt.target.getAttribute('cx');
		circleStartY = evt.clientY / _picFaktor - evt.target.getAttribute('cy');
	} else {
		eType = 'touchmove';
		circleStartX = evt.touches[0].clientX / _picFaktor - evt.target.getAttribute('cx');
		circleStartY = evt.touches[0].clientY / _picFaktor - evt.target.getAttribute('cy');
	}
	var circleEle = document.getElementById('K-analyse-feinboden-bodenartencircle');
	circleEle.addEventListener(eType, circleBodendiagrammMove, true);

	var imageEle = document.getElementById('K-analyse-feinboden-bodenartenimage');
	imageEle.addEventListener(eType, circleBodendiagrammMove, true);
	imageEle.setAttribute('cursor', 'pointer');
	imageEle.setAttribute('pointer-events', 'all');
}

function circleBodendiagrammStop(evt) {
	evt.preventDefault();

	var eType = 'mousemove';
	if (!evt.clientX) {
		eType = 'touchmove';
	}
	var circleEle = document.getElementById('K-analyse-feinboden-bodenartencircle');
	circleEle.removeEventListener(eType, circleBodendiagrammMove, true);
	var imageEle = document.getElementById('K-analyse-feinboden-bodenartenimage');
	imageEle.removeEventListener(eType, circleBodendiagrammMove, true);
	imageEle.setAttribute('cursor', 'default');
	imageEle.setAttribute('pointer-events', 'none');
	//document.getElementById("K-analyse-feinboden-bodenartencircle").setAttribute("pointer-events","all");
}

function circleBodendiagrammMove(evt) {
	evt.preventDefault();
	evt.stopPropagation();

	var xTon, ySchluff;
	if (evt.clientX) {
		xTon = evt.clientX / _picFaktor - circleStartX;
	} else {
		xTon = evt.touches[0].clientX / _picFaktor - circleStartX;
	}

	if (xTon < _xTon0) xTon = _xTon0;
	if (xTon > _xTon100) xTon = _xTon100;

	if (evt.clientY) {
		ySchluff = evt.clientY / _picFaktor - circleStartY;
	} else {
		ySchluff = evt.touches[0].clientY / _picFaktor - circleStartY;
	}
	if (ySchluff > _ySchluff0) ySchluff = _ySchluff0;
	if (ySchluff < _ySchluff100) ySchluff = _ySchluff100;

	var valueTon = parseInt((xTon - _xTon0) / ((_xTon100 - _xTon0) / 100));
	var valueSchluff = parseInt(100 - (ySchluff - _ySchluff100) / ((_ySchluff0 - _ySchluff100) / 100));

	calcKFeinbodenTexturanalyseAndererboden(valueTon, valueSchluff, 'ton');
}

function calcKFeinbodenTexturanalyseAndererboden(valueTon, valueSchluff, aktSlider, sliderTon, sliderSchluff) {
	var valueSand;
	if (valueTon + valueSchluff > 100) {
		// Hier wird je nach Slider, der andere angepasst
		if (aktSlider == 'ton') {
			valueSchluff = 100 - valueTon;
		} else {
			valueTon = 100 - valueSchluff;
		}
		valueSand = 0;
	} else {
		valueSand = 100 - (valueTon + valueSchluff);
	}

	var id = 'K-analyse-feinboden-texturanalyse-andererboden';
	if (typeof sliderTon == 'undefined') {
		sliderTon = document.getElementById(id + '-ton');
		sliderSchluff = document.getElementById(id + '-schluff');
	}

	// Sliderwerte setzen
	sliderTon.value = valueTon;
	sliderSchluff.value = valueSchluff;
	document.getElementById(id + '-sand').value = valueSand;

	// Slidertxt anpassen
	document.getElementById('slidertxt-' + id + '-ton').value = valueTon;
	document.getElementById('slidertxt-' + id + '-schluff').value = valueSchluff;
	document.getElementById('slidertxt-' + id + '-sand').value = valueSand;

	// Punkt auf Diagrammsetzen
	var cx = ((_xTon100 - _xTon0) / 100) * valueTon + _xTon0;
	var cy = _ySchluff0 - ((_ySchluff0 - _ySchluff100) / 100) * valueSchluff;
	var circleEle = document.getElementById('K-analyse-feinboden-bodenartencircle');
	circleEle.setAttribute('cx', cx);
	circleEle.setAttribute('cy', cy);
	setKFaktor(id);
}

// --------------------------
// * K-Auswerten
// --------------------------

function setKFaktor(val) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);

	var kfaktor = 0;
	var text = '';
	var id = faktor + '-' + methode; //
	var id2;

	var printObj = {};
	printObj.Method = document.getElementById(id).innerHTML; // Radio-Button-Text
	printObj.Para = [];
	_rPrintTexte.K.Methods = [];
	_rPrintTexte.K.Methods.push(printObj);

	//#am NRW
	switch (methode) {
		case 'map':
			kfaktor = document.getElementById('K-map-input').innerHTML;
			if (kfaktor == '') kfaktor = 0;
			Snackbar.close();
			displayMapFullScreen(false, 'k'); //ggf. Abschalten des FullScreenModus
			
			break;
		case 'analyse':
			var kFaktorStein = 0;
			var kFaktorFeinboden = 0;

			// 1. Steinbedeckung
			var subMethode = getSelectedSubMethodeFromRad('KsteinbedeckungRad'); // Kann nicht von val genommen werden
			printObj = {};
			printObj.Title = 'Schätzung des Einflusses der Steinbedeckung (K<sub>Stein</sub>)';
			printObj.Method = document.getElementById(id + '-steinbedeckung-' + subMethode).innerHTML; // Radio-Button-Text
			printObj.Para = [];
			_rPrintTexte.K.Methods.push(printObj);

			switch (subMethode) {
				case 'messung':
					var steinbedeckung = document.getElementById(id + '-steinbedeckung-messung-steinbedeckung').value;
					text = getLabelTextFromFormEle(id + '-steinbedeckung-messung-steinbedeckung');
					storeToPrint(printObj, text, steinbedeckung);
					kFaktorStein = calcKSteinbedeckungMessung(steinbedeckung);
					break;

				case 'schaetzung':
					id2 = id + '-steinbedeckung-schaetzung';
					ele = document.getElementById(id2 + '-beschrieb');
					text = getLabelTextFromFormEle(id2 + '-beschrieb');
					storeToPrint(printObj, text, getTextFromSelected(ele));

					ele = document.getElementById(id2 + '-bodenart');
					text = getLabelTextFromFormEle(id2 + '-bodenart');
					storeToPrint(printObj, text, getTextFromSelected(ele));

					ele = document.getElementById(id2 + '-zustandsstufe');
					text = getLabelTextFromFormEle(id2 + '-zustandsstufe');
					storeToPrint(printObj, text, getTextFromSelected(ele));
					kFaktorStein = getValueFromSelected(ele);

					break;
			}

			storeToPrint(printObj, 'K<sub>Stein</sub>', kFaktorStein);
			fillValuesInPage(faktor + 'stein', kFaktorStein);

			// 2. Feinboden
			subMethode = getSelectedSubMethodeFromRad('KfeinbodenRad'); // Kann nicht von val genommen werden
			printObj = {};
			printObj.Title = 'Schätzung des Einflusses des Feinbodens (K<sub>Feinboden</sub>)';
			printObj.Method = document.getElementById(id + '-feinboden-' + subMethode).innerHTML; // Radio-Button-Text
			printObj.Para = [];
			_rPrintTexte.K.Methods.push(printObj);

			switch (subMethode) {
				case 'texturanalyse':
					id2 = id + '-feinboden-texturanalyse';
					ele = document.getElementById(id2 + '-bodenart');
					text = getLabelTextFromFormEle(id2 + '-bodenart');
					storeToPrint(printObj, text, getTextFromSelected(ele));
					var bodenart = getValueFromSelected(ele);
					if (bodenart == 'sandboden') {
						kFaktorFeinboden = getValueFromSelected(id2 + '-sandboden');
					} else {
						id2 = id2 + '-andererboden';
						ele = document.getElementById(id2 + '-ton');
						text = getLabelTextFromFormEle(id2 + '-ton');
						var ton = parseInt(ele.value);
						storeToPrint(printObj, text, ton);

						ele = document.getElementById(id2 + '-schluff');
						text = getLabelTextFromFormEle(id2 + '-schluff');
						var schluff = parseInt(ele.value);
						storeToPrint(printObj, text, schluff);

						ele = document.getElementById(id2 + '-sand');
						text = getLabelTextFromFormEle(id2 + '-sand');
						var sand = parseInt(ele.value);
						storeToPrint(printObj, text, sand);

						// Summe der drei Bodenarten immer 100 %
						if (_kfeinbodenandererbodenTab != null) {
							kFaktorFeinboden = _kfeinbodenandererbodenTab[ton + '_' + sand + '_' + schluff];
						}
						if (typeof kFaktorFeinboden != 'undefined') {
							//console.log(ton + "_" + sand + "_" + schluff + " : " + kFaktorFeinboden);
							kFaktorFeinboden = kFaktorFeinboden.toFixed(2);
						}
					}

					break;
				case 'bodenanalyse':
					id2 = 'K-analyse-feinboden-bodenanalyse';
					ele = document.getElementById(id2 + '-schluff');
					text = getLabelTextFromFormEle(id2 + '-schluff');
					var fUffS = parseInt(ele.value);
					storeToPrint(printObj, text, fUffS);

					ele = document.getElementById(id2 + '-ton');
					text = getLabelTextFromFormEle(id2 + '-ton');
					var fT = parseInt(ele.value);
					storeToPrint(printObj, text, fT);

					ele = document.getElementById(id2 + '-sand');
					text = getLabelTextFromFormEle(id2 + '-sand');
					var fSffS = parseInt(ele.value);
					storeToPrint(printObj, text, fSffS);

					ele = document.getElementById(id2 + '-orgsubstanz');
					text = getLabelTextFromFormEle(id2 + '-orgsubstanz');
					var foS = parseInt(ele.value);
					storeToPrint(printObj, text, foS);

					ele = document.getElementById(id2 + '-aggregatklasse');
					text = getLabelTextFromFormEle(id2 + '-aggregatklasse');
					storeToPrint(printObj, text, getTextFromSelected(ele));
					var A = parseInt(getValueFromSelected(ele));

					ele = document.getElementById(id2 + '-durchlaessigkeitsklasse');
					text = getLabelTextFromFormEle(id2 + '-durchlaessigkeitsklasse');
					storeToPrint(printObj, text, getTextFromSelected(ele));
					var P = parseInt(getValueFromSelected(ele));

					kFaktorFeinboden = calcKFeinbodenBodenanalyse(fUffS, fT, fSffS, foS, A, P);
					break;
				case 'schaetzung':
					id2 = id + '-feinboden-schaetzung';
					ele = document.getElementById(id2 + '-beschrieb');
					text = getLabelTextFromFormEle(id2 + '-beschrieb');
					storeToPrint(printObj, text, getTextFromSelected(ele));

					ele = document.getElementById(id2 + '-bodenart');
					text = getLabelTextFromFormEle(id2 + '-bodenart');
					storeToPrint(printObj, text, getTextFromSelected(ele));

					ele = document.getElementById(id2 + '-zustandsstufe');
					text = getLabelTextFromFormEle(id2 + '-zustandsstufe');
					storeToPrint(printObj, text, getTextFromSelected(ele));

					kFaktorFeinboden = getValueFromSelected(ele);
					break;
			}

			storeToPrint(printObj, 'K<sub>Feinboden</sub>', kFaktorFeinboden);
			fillValuesInPage(faktor + 'feinboden', kFaktorFeinboden);

			kfaktor = (kFaktorStein * kFaktorFeinboden).toFixed(2);
			break;

		case 'faktor':
			kfaktor = document.getElementById(id + '-faktor').value;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, kfaktor);
			break;
	}
	fillValuesInPage(faktor, kfaktor);
}

// --------------------------
// * K-Berechnen
// --------------------------

function calcKSteinbedeckungMessung(steinbedeckung) {
	if (steinbedeckung < 1.5) {
		return 1;
	} else {
		return (1.1 * Math.exp(-0.024 * steinbedeckung) - 0.06).toFixed(2);
	}
}

function calcKFeinbodenBodenanalyse(fUffS, fT, fSffS, foS, A, P) {
	var kFaktorFeinboden = 0;
	var K1, K2;
	if (fUffS < 70) {
		K1 = 2.77 * Math.pow(10, -5) * Math.pow(fUffS * (100 - fT), 1.14);
	} else {
		K1 = 1.75 * Math.pow(10, -5) * Math.pow(fUffS * (100 - fT), 1.14) + 0.0024 * fSffS + 0.161;
	}
	if (foS < 4) {
		K2 = (K1 * (12 - foS)) / 10;
	} else {
		K2 = K1 * 0.8;
	}
	if (K2 > 0.2) {
		kFaktorFeinboden = K2 + 0.043 * (A - 2) + 0.033 * (4 - P);
	} else {
		kFaktorFeinboden = 0.091 - 0.34 * K2 + 1.79 * Math.pow(K2, 2) + 0.24 * K2 * A + 0.033 * (4 - P);
	}
	return kFaktorFeinboden.toFixed(2);
}

//************************************************
// * LS Hangform
//************************************************

// ----------------------------
// * LS-Initialisieren und Laden
// ----------------------------

function initLS(val) {
	// Zuweisung von Events
	// Radio-Button
	var arr = Array.prototype.slice.call(document.getElementsByClassName('LSRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			loadLS(this.getAttribute('id'));
		});
	});

	addEventsLSSedimentHinweis(document.getElementById('section-LS-eingabe'));
	// Slider, input type.range objecte
	initInputRange(document.getElementById('section-LS').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	initABAGhelp(document.getElementById('section-LS').getElementsByClassName('helpbutton'));
	loadLS(val);
}

function addEventsLSSedimentHinweis(ele) {

	arr = Array.prototype.slice.call(ele.getElementsByTagName('input'));
	arr.forEach(function(ele) {
		if (ele.type == 'range') {
			ele.addEventListener('mousedown', function() {
				Snackbar.close();
				ele.addEventListener('mouseup', displayLSSedimentHinweis);
			});
			ele.addEventListener('touchstart', function(evt) {
				Snackbar.close();
				ele.addEventListener('touchend', displayLSSedimentHinweis);
			});
		}

		if (ele.classList.contains('slidertxt')) {
			ele.addEventListener('focus', function() {
				//console.log('focus');
				//Snackbar.close(); // Wenn dann auf das naechste slidertxt geklickt wird ist das Snackbar sofort weg
				if (!Snackbar.current) {
					ele.addEventListener('blur', displayLSSedimentHinweis); // blur kommt wenn der naechste fokusiert wird und dann ist zweimal das OK dran
				}
			});
		}
	});

}
function displayLSSedimentHinweis(e) {
	//console.log(e.target);						 
	e.target.removeEventListener('mouseup', displayLSSedimentHinweis);
	e.target.removeEventListener('blur', displayLSSedimentHinweis); 
	if (_lsHinweis == null) return;
	Snackbar.show(_lsHinweis, 'OK');
	_lsHinweis = null;
}

function loadLS(val) {
	console.log("LoadLS " + val + " hasMap: " + hasMap);
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...
	var mapRadButton = document.getElementById('LS-map');
	if (!hasMap) {
		mapRadButton.classList.add('hidden');
		// LS-eingabe ist die voreingestellt Auswahl
		var ele = document.getElementById('LS-eingabe');
		/*
		ele.classList.add('radchecked');
		ele.classList.add('bg--dark--' + val);
		ele.classList.remove('radunchecked');
		ele.classList.remove('bg--' + val);
		*/
		ele.click();
	} else {
		// Nur einmal machen, ansonsten kommt man immer wieder zur Karte mit click(), ggf. will man das ja gar nicht mehr
		if (mapRadButton.classList.contains('hidden')) {
			mapRadButton.classList.remove('hidden');
			mapRadButton.click();
		}
	}

	// Wenn ueber runde Buttons nur Laden des Faktors
	var faktor = getFaktor(val);
	var methode;
	//kein automatisches Fullmap bei Mobile gewünscht
	var fullMap = false; //true;
	if (getMethode(val) == null) {
		methode = getSelectedMethodeFromRad(faktor + 'Rad');
		val = faktor + '-' + methode;
	}

	//wenn über Wischbewegung auf LS gewechselt,
	//wird, dann nicht in den Fullscreen wechseln
	if (getMethode(val) == 'swipe') {
		if (hasMap) {
			fullMap = false;
			methode = 'map';
		} else {
			methode = getSelectedMethodeFromRad(faktor + 'Rad');
		}
		val = faktor + '-' + methode;
	}

	displayFaktorMethode(val);

	// Wenn Methode analyse und erster Aufruf, laden der Dateien
	methode = getMethode(val);

	//Wenn Karte erlaubt (Bayern) dann starten
	if (methode == 'map') {
		//#am NRW
		initMap(fullMap, 'ls');
	} else {
		// Snackbar von der Karte entfernen (Angabe stoert sonst)
		Snackbar.close();
	}
	setLSFaktor(val);
}

function displayMap() {
	var modal = document.getElementById(id + '-content'); // nicht global
	modal.style.display = 'block';
	modal.addEventListener('click', closeModal);
	modal.modal = modal; // Parameteruebergabe
}

//#am NRW
//function displayLSMapFullScreen(flag) {
function displayMapFullScreen(flag, faktor) {
	var mapPar = document.getElementById(faktor + 'map').parentNode;

	if (typeof flag == 'undefined') {
		if (mapPar.classList.contains('mapdisplay')) flag = false;
		else flag = true;
	}
	if (flag) {
		mapPar.classList.add('mapdisplay');
		//#am NRW
		document.getElementById(faktor + 'map').style.height = '100%';

		//#am NRW
		document.body.insertAdjacentHTML(
			'beforeend',
			'<button id="mBut" class="btn--float closebutton" onclick="displayMapFullScreen(false,\'' +
				faktor +
				'\')">' +
				'<span aria-hidden="true"><svg class="svg-inline--fa fa-times fa-w-14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M231.6 256l130.1-130.1c4.7-4.7 4.7-12.3 0-17l-22.6-22.6c-4.7-4.7-12.3-4.7-17 0L192 216.4 61.9 86.3c-4.7-4.7-12.3-4.7-17 0l-22.6 22.6c-4.7 4.7-4.7 12.3 0 17L152.4 256 22.3 386.1c-4.7 4.7-4.7 12.3 0 17l22.6 22.6c4.7 4.7 12.3 4.7 17 0L192 295.6l130.1 130.1c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17L231.6 256z"/></svg>' +
				'</span></button>'
		);
	} else {
		mapPar.classList.remove('mapdisplay');
		//#am NRW
		document.getElementById(faktor + 'map').style.height = 'calc(50vh)';

		el = document.getElementById('mBut');
		if (el) el.parentNode.removeChild(el);
		//snackbar wieder löschen (können mehrere sein)
		var sBars = document.querySelectorAll('.paper-snackbar');
		for (var i = 0; i < sBars.length; ++i) {
			sBars[i].style.opacity = 0;
		}
	}
	map.invalidateSize(); // redraw
}

function clearLSDetailliertSegment() {
	//console.log("clearLSDetailliertSegment")
	document.getElementById('LS-map-input').innerHTML = '';
}

function loadLSDetailliertSegment(segments) {
	var id = 'LS-map';
	//#am NRW
	displayMapFullScreen(false, 'ls'); //ggf. Abschalten des FullScreenModus

	var ele = document.getElementById(id + '-input');
	if (segments.length == 0) {
		ele.innerHTML = 'Es konnten keine Höhen ermittelt werden.';
		ele.scrollIntoView(true);
		return;
	}

	var txts = '';
	var lengthSegMax = 0;
	var slopeSegMax = 0;
	var i;
	for (i = 0, len = segments.length; i < len; i++) {
		lengthSegMax = Math.max(lengthSegMax, segments[i].length);
		slopeSegMax = Math.max(lengthSegMax, segments[i].slope);
	}
	lengthSegMax = Math.max(lengthSegMax, 500);
	lengthSegMax = parseInt(lengthSegMax);

	for (i = 0, len = segments.length; i < len; i++) {
		var id2 = id + '-neigung-' + i;
		txts += '<fieldset><legend>Teilstück ' + (i + 1) + '</legend>';
		txts += "<div><label for='" + id2 + "'>Neigung [%]</label>";
		txts += "<div><input type='number' id='slidertxt-" + id2 + "' class='slidertxt' value='0' />";
		txts += "<input type='range' id='" + id2 + "' min='0' max='55' value='" + segments[i].slope + "' style='width:calc(100% - 100px);margin-left:5px;'/>";
		txts += '</div></div>';

		id2 = id + '-laenge-' + i;
		txts += "<div><label for='" + id2 + "'>Länge [m]</label>";
		//console.log(segments[i].length);
		txts += "<div><input type='number' id='slidertxt-" + id2 + "' class='slidertxt' value='" + parseInt(segments[i].length) + "' />";
		txts += "<input type='range' id='" + id2 + "' min='0' max='" + lengthSegMax + "' value='" + parseInt(segments[i].length) + "' style='width:calc(100% - 100px);margin-left:5px;'/>";
		txts += '</div></div></fieldset>';
	}
	ele.innerHTML = txts;
	addEventsLSSedimentHinweis(ele);
	initInputRange(ele.getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	ele.scrollIntoView(true);

	setLSFaktor(id);
}

// --------------------------
// * LS-Auswerten
// --------------------------

function setLSFaktor(val) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);

	//console.log(val);

	var lsfaktor = 0;
	var text = '';
	var id = faktor + '-' + methode; //

	//var text = document.getElementById(id).innerHTML; // Radio-Button-Text

	var printObj = {};
	printObj.Method = document.getElementById(id).innerHTML; // Radio-Button-Text
	printObj.Para = [];
	_rPrintTexte.LS.Methods = [];
	_rPrintTexte.LS.Methods.push(printObj);

	switch (methode) {
		case 'eingabe':
		case 'map':
			//var subMethode = getSelectedSubMethodeFromRad("LSDetailliertRad"); // Kann nicht von val genommen werden
			//id = faktor + "-" + methode + "-" + subMethode;

			//Berechne Gesamte Hanglaenge, Durchschnittliche Neigung
			var neigSum = 0;
			var neigArray = [];
			var laengeArray = [];
			var laengeGesArray = [];
			laengeGesArray.push(0);
			var i = 0;
			var ele = document.getElementById(id + '-neigung-' + i);
			_lsHinweis = null;
			while (ele != null) {
				var neigung = parseInt(document.getElementById(id + '-neigung-' + i).value);
				var laenge = parseInt(document.getElementById(id + '-laenge-' + i).value);
				// Nur aufnehmen, wenn Laenge > 0 geaendert
				if (laenge > 0) {
					storeToPrint(printObj, 'Teilstück', i + 1);

					text = getLabelTextFromFormEle(id + '-neigung-' + i);
					storeToPrint(printObj, text, neigung);
					text = getLabelTextFromFormEle(id + '-laenge-' + i);
					storeToPrint(printObj, text, laenge);

					neigArray.push(neigung);
					laengeArray.push(laenge);

					neigSum += neigung * laenge;
					laengeGesArray.push(laengeGesArray[laengeGesArray.length - 1] + laenge);
				}
				i++;
				ele = document.getElementById(id + '-neigung-' + i);
			}

			_gesLaenge = laengeGesArray[laengeGesArray.length - 1];
			if (_gesLaenge > 0) {
				var lLaengeGes = 0;

				_gesNeig = neigSum / _gesLaenge;
				_expM = calcExponentM(_gesNeig);
				// Berechne LS-Faktor
				var LSn = calcLFaktor(laengeGesArray[1], _expM) * calcSFaktor(neigArray[0]); //Berechne LS1
				for (var j = 1; j < laengeGesArray.length - 1; ++j) {
					var LSVor = LSn;
					lLaengeGes = laengeGesArray[j] / laengeGesArray[j + 1];
					// Rekursiv-Formel zur Berechnung des naechsten Teilstuecks aus dem vorherigen
					LSn = calcLFaktor(1, _expM) * calcSFaktor(neigArray[j]) * (Math.pow(laengeGesArray[j + 1], _expM) - lLaengeGes * Math.pow(laengeGesArray[j], _expM)) + lLaengeGes * LSn;
					if (LSn < LSVor) {
						_gesLaenge = 0;
						_gesNeig = 0;
						lsfaktor = 0;
						_lsHinweis = 'Die Berechnung zeigt, dass im ' + parseInt(j + 1) + '-ten Teilstück Sedimentation auftritt. Die ABAG gilt nur zwischen den Bereichen, in denen der Abfluss einsetzt und dem Beginn der Sedimentation. Bitte Eingaben korrigieren.';
						break;
					}
				}
				if (_gesLaenge > 0) {
					lsfaktor = LSn.toFixed(2);
				}
			}

			break;
		case 'faktor':
			//_rPrintTexte.LS.Method = text; // 1. Radio-Button-Text
			lsfaktor = document.getElementById(id + '-faktor').value;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, lsfaktor);
			break;
	}
	fillValuesInPage(faktor, lsfaktor);
}

function calcExponentM(neig) {
	//m = Min(0.5, 1.2 * Math.Sin(Math.Atan(sngS / 100)) ^ (1 / 3))
	var m = Math.min(0.5, 1.2 * Math.pow(Math.sin(Math.atan(neig / 100)), 1 / 3));
	return m;
}

function calcLFaktor(laenge, _expM) {
	if (laenge == 0) return 0;
	return Math.pow(laenge / 22.1, _expM);
}

function calcSFaktor(neig) {
	var sFaktor = -1.5 + 17 / (1 + Math.exp(2.3 - 6.1 * Math.sin(Math.atan(neig / 100))));
	return sFaktor;
}

//************************************************
// * C Fruchtfolge, Bewirtschaftung
//************************************************

// ----------------------------
// * C-Initialisieren und Laden
// ----------------------------

function initC(val) {
	// Callback-Funtkion des HTML-Fragment-Ladens
	// val ist entweder oekologisch-konventionell-faktor;

	// Zuweisung von Events
	// Radio-Button
	//var arr = Array.prototype.slice.call(document.getElementsByClassName('CRad'));
	var arr = document.querySelectorAll('.CRad')
	arr.forEach(function(ele) {
		ele.addEventListener('click', function() {
			loadC(this.getAttribute('id'));
		});
	});

	// Dateien laden und select-Boxen fuellen, die nur einmal gefuellt werden muessen
	loadData(_folder + 'cmiscanthus.json', 'C-dauerkulturen-miscanthus', insertDataCDauerkulturenMitNutzungsdauer);
	loadData(_folder + 'csilphie.json', 'C-dauerkulturen-silphie', insertDataCDauerkulturenMitNutzungsdauer);


	// Event-Selectlisten
	document.querySelectorAll('.CFruchtfolgenRad').forEach(function(ele) {
		ele.addEventListener('click', function() {
			loadCFruchtfolgen(this.getAttribute('id'));
		});
	});
	
	document.getElementById('C-fruchtfolgen-berechnung-add').addEventListener('click', function() {
		addCFruchtfolgeGlied();
	});

	document.getElementById('C-dauerkulturen-anbausystem').addEventListener('change', function() {
		loadCFruchtfolgenDauerkulturen('C-dauerkulturen-' + this.value);
	});

	document.getElementById('C-dauerkulturen-miscanthus').addEventListener('change', function() {
		setCFaktor(this.getAttribute('id'));
	});

	document.getElementById('C-dauerkulturen-silphie').addEventListener('change', function() {
		setCFaktor(this.getAttribute('id'));
	});

	// Slider, input type.range objecte
	initInputRange(document.getElementById('section-C').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);

	initABAGhelp(document.getElementById('section-C').getElementsByClassName('helpbutton'));

	loadC(val);
}

function loadC(val) {
	console.log("loadC: " + val);
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...

	// Wenn ueber runde Buttons nur Laden des Faktors
	var faktor = getFaktor(val);
	var methode;
	if (getMethode(val) == null) {
		methode = getSelectedMethodeFromRad(faktor + 'Rad');
		val = faktor + '-' + methode; // C-fruchtfolgen, C-dauerkulturen, C-faktor
	}
	
	displayFaktorMethode(val);
	methode = getMethode(val); // fruchtfolgen,dauerkulturen,faktor

	//console.log("loadC - methode: " + methode);
	switch (methode) {
		case 'fruchtfolgen':
			// "berechnung" oder "deutschermittelwert" von gedrueckten Button auslesen
			var subMethode = getSelectedSubMethodeFromRad('CFruchtfolgenRad'); 
			val += '-' + subMethode;
			loadCFruchtfolgen(val);
			break;
		case 'dauerkulturen':
			val += '-' + getValueFromSelected(val + '-anbausystem'); //z.B. C-dauerkulturen-gruenland
			
			console.log('dauerkulturen ' + val);
			loadCFruchtfolgenDauerkulturen(val);
			break;
		default:
			setCFaktor(val);
			break;
	}

}

function displayCHinweis(e) {
	console.log("displayCHinweis");
	if (_cHinweis == null) return;
	Snackbar.show(_cHinweis, 'OK');
	_cHinweis = null;
}

function loadCFruchtfolgen(val) {
	//console.log("loadCFruchtfolgen: " + val);
	// "berechnung" oder "deutschermittelwert"
	var subMethode = getSubMethode(val);
	displayRadFaktorMethode('C', subMethode, 'CFruchtfolgenRad');
	loadCFruchtfolgenDauerkulturen(val);
	
}

function displayCFruchtfolgenDauerkulturen(val) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);
	var fruchtfolge = getSubMethode(val);
	// An und ausschalten der Unterpunkte
	var arr = Array.prototype.slice.call(document.getElementsByClassName('section-' + faktor + '-' + methode));
	arr.forEach(function(ele) {
		if (ele.getAttribute('id').indexOf(faktor + '-' + methode + '-' + fruchtfolge) !== -1) {
			ele.classList.remove('hidden');
		} else {
			ele.classList.add('hidden');
		}
	});
}

function loadCFruchtfolgenDauerkulturen(val) {
	//console.log("loadCFruchtfolgenDauerkulturen: " + val); // val ist C-fruchtfolgen-berechung oder C-dauerkulturen-gruenland
	displayCFruchtfolgenDauerkulturen(val);

	var fruchtfolge = getSubMethode(val);
	//console.log("loadCFruchtfolgenDauerkulturen: " + fruchtfolge);
	switch (fruchtfolge) {
		case 'berechnung':
			if (_cfruchtfolgeTab == null) {
				loadData(_folder + 'cfruchtfolge.json', 'C-fruchtfolgen-berechnung', insertDataCFruchtfolge);
			} else {
				setCFaktor(val);
			}
			break;
		case 'hopfen':
			if (_chopfenTab == null) {
				loadData(_folder + 'chopfen.json', 'C-dauerkulturen-hopfen', insertDataCHopfen);
			} else {
				setCFaktor(val);
			}
			break;
		case 'wein':
			if (_cweinTab == null) {
				loadData(_folder + 'cwein.json', 'C-dauerkulturen-wein', insertDataCWein);
			} else {
				setCFaktor(val);
			}
			break;
		default:
			setCFaktor(val);
			break;
	}
	setPFaktor();
}

function insertDataCFruchtfolge(data, id) {
	// erstes Glied
	// console.log("insertDataCFruchtfolge " + id);
	// Callback beim Laden von C
	_cfruchtfolgeTab = data;
	
	// erstes Fruchtfolgeglied

	document.getElementById('C-fruchtfolgen-berechnung-1').addEventListener('change', function() { // Click auf die Gruppe
		var num = this.getAttribute('id').substring(this.getAttribute('id').lastIndexOf('-') + 1);
		loadCFruchtfolgeFrucht(num); // Laden der jeweiligen Fruechte der Gruppe
	});

	document.getElementById('C-fruchtfolgen-berechnung-frucht-1').addEventListener('change', function() { // Click auf die Frucht
		//console.log("Click auf frucht"); // laueft zweimal rein
		var num = this.getAttribute('id').substring(this.getAttribute('id').lastIndexOf('-') + 1);
		loadCFruchtfolgeMethode(num); // Laden der jeweiligen Methode der Gruppe
	});

	// Beginnend mit 1
	loadCFruchtfolge(1);	
	
}

function loadCFruchtfolge(num) {
	var id = "C-fruchtfolgen-berechnung-" + num.toString() // Die Gruppe
	var txts = '';
	for (var rec in _cfruchtfolgeTab) {
		txts += '<option value="' + rec + '">' + rec + '</option>';
	}
	document.getElementById(id).innerHTML = txts;

	// Laden der jeweiligen Frucht der Gruppe
	loadCFruchtfolgeFrucht(num);
	
}

function loadCFruchtfolgeFrucht(num) {
	var gruppe = getValueFromSelected("C-fruchtfolgen-berechnung-" + num.toString()); // Die Gruppe

	var txts = '';
	var value;
	//console.log(_cfruchtfolgeTab[gruppe]);
	for (var rec in _cfruchtfolgeTab[gruppe]) {
		//console.log(typeof _cfruchtfolgeTab[gruppe][rec]);
		// Im Value steht entweder die Frucht (wenn es eine Anbaumethodenauswahl gibt) oder schon der Gamma-Wert
		if (typeof _cfruchtfolgeTab[gruppe][rec] == "number") {
			value = _cfruchtfolgeTab[gruppe][rec];
		} else {
			value = rec;
		}
		txts += '<option value="' + value + '">' + rec + '</option>';
	}
	
	var ele = document.getElementById('C-fruchtfolgen-berechnung-frucht-' + num.toString());
	ele.innerHTML = txts;
	//console.log(txts);
	
	// Laden der Methoden
	loadCFruchtfolgeMethode(num);

}

function loadCFruchtfolgeMethode(num) {
	//console.log("loadCFruchtfolgeMethode");
	var gruppe = getValueFromSelected("C-fruchtfolgen-berechnung-" + num.toString());
	var fruchtTab = _cfruchtfolgeTab[gruppe];
	var frucht = getValueFromSelected("C-fruchtfolgen-berechnung-frucht-" + num.toString());
	var fruchtText = getTextFromSelected("C-fruchtfolgen-berechnung-frucht-" + num.toString());
	
	if (fruchtText == null) {
		fruchtText = "";
	}
	if (fruchtText.indexOf('jährigen') > 0) {
		fruchtText = "Kleegras (u.a.) " + fruchtText;
	}

	/* Hinzufuegen des Namens bei Collabsible */
	//var carReturn = "&nbsp;"; // in zweite Zeile
	//if (frucht.length > 70) carReturn = "<br>";
	var labelSpan = document.querySelector('#C-fruchtfolgen-berechnung-glied-' + num.toString()).querySelector('label>span');
	var txt = labelSpan.innerHTML;
	txt = txt.substring(0,txt.indexOf(":") + 1);
	labelSpan.innerHTML = txt + " " + fruchtText;
	
	
	var divNode;
	var txts = '';
	var ele = document.getElementById('C-fruchtfolgen-berechnung-methode-' + num.toString());
	
	// In Frucht ist nun die Frucht notiert oder bereits der Gamma-Wert
	// Die Auswahlbox nur anzeigen, wenn es eine Auswahl gibt!
	
	// Erstellen der Auswahlbox
	if (ele == null && isNaN(frucht)) {
		var parEle = document.querySelector('.collapsible-C-fruchtfolgen-berechnung-nummer-' + num.toString() + '-area');
		divNode = document.createElement('div'); 
		txts = '<label for="C-fruchtfolgen-berechnung-methode-' + num.toString() + '">Aussaatverfahren</label><select class="C-fruchtfolgen-berechnung-methode" id="C-fruchtfolgen-berechnung-methode-' + num.toString() + '"></select>';
		divNode.innerHTML = txts;
		parEle.appendChild(divNode);

		document.getElementById('C-fruchtfolgen-berechnung-methode-' + num.toString()).addEventListener('change', function() { // Click auf die Methode
			setCFaktor('C-fruchtfolgen-berechnung');
		});
		
	}

	if (isNaN(frucht)) {
		var methodeTab = fruchtTab[frucht];
		for (var rec in methodeTab) {
			txts += '<option value="' + methodeTab[rec] + '">' + rec + '</option>';
		}
		document.getElementById('C-fruchtfolgen-berechnung-methode-' + num.toString()).innerHTML = txts;
	} else {
		if (ele != null) ele.parentNode.remove();
	}
	
	setCFaktor('C-fruchtfolgen-berechnung');
}

function addCFruchtfolgeGlied() {

	var txts = "";
	
	var num = 1; // die interne Nummerierung stimmt nicht unbedingt mit der nach außen sichtbaren Nummer überein, da Glieder geloescht werden koennen
	var fruchtfolgelist = document.querySelectorAll('.C-fruchtfolgen-berechnung-glied');
	fruchtfolgelist.forEach(function(ele) {
		num = Math.max(parseInt(ele.id.substring(ele.id.lastIndexOf('-') + 1)), num); // wenn zwischendurch geloescht worden ist, dann kann man nicht mehr nur die Anzahl nehmen
	});
	
	num++;
	
	var fruchtnum = fruchtfolgelist.length + 1
	
	/*
	// Offen gestaltet, mit fieldset
	
	var parEle = document.createElement('fieldset');
	parEle.id = 'C-fruchtfolgen-berechnung-glied-' + num.toString();
	parEle.classList.add("C-fruchtfolgen-berechnung-glied");

	var button = document.createElement('button');
	button.id = 'C-fruchtfolgen-berechnung-remove-' + num.toString();
	button.classList.add("btn--float","removebutton");
	button.innerHTML = "-";
	parEle.appendChild(button);

	var legend = document.createElement('legend');
	legend.appendChild(document.createTextNode("Fruchtfolgeglied " + num.toString()));
	parEle.appendChild(legend);

	// In den DOM einfuegen
	var appendSibling = document.getElementById('C-fruchtfolgen-berechnung-glied-' + (num - 1).toString());
	appendSibling.parentNode.insertBefore(parEle,appendSibling.nextSibling);

	*/
	
	// Alternativ: Collapsible
	var parEle = document.createElement('div');
	parEle.id = 'C-fruchtfolgen-berechnung-glied-' + num.toString();
	parEle.classList.add("C-fruchtfolgen-berechnung-glied","collapsible-wrap","card","no-pad");
	
	var txts = '<input type="checkbox" id="collapsible-C-fruchtfolgen-berechnung-nummer-' + num.toString() + '" checked><label for="collapsible-C-fruchtfolgen-berechnung-nummer-' + num.toString() + '"><span>Feldfrucht im Jahr ' + fruchtnum.toString() + ': </span><button id="C-fruchtfolgen-berechnung-remove-' + num.toString() + '" class="btn--float removebutton">-</button></label><div class="collapsible-C-fruchtfolgen-berechnung-nummer-' + num.toString() + '-area"></div>';

	parEle.innerHTML = txts;

	// Einfuegenode
	// In den DOM einfuegen, funktioniert so, da was immer auch ist, der vorhergehige num-1 hat.
	var appendSibling = document.getElementById('C-fruchtfolgen-berechnung-glied-' + (num - 1).toString());
	appendSibling.querySelector('input[type="checkbox"').checked = false;
	appendSibling.parentNode.insertBefore(parEle,appendSibling.nextSibling);

	parEle = document.querySelector('.collapsible-C-fruchtfolgen-berechnung-nummer-' + num.toString() + '-area');

	// Die Auswahllisten
	var divNode = document.createElement('div'); 
	var txts = '<label for="C-fruchtfolgen-berechnung-' + num.toString() + '">Gruppe</label><select id="C-fruchtfolgen-berechnung-' + num.toString() + '"></select>';
	divNode.innerHTML = txts;
	parEle.appendChild(divNode);

	divNode = document.createElement('div'); 
	txts = '<label for="C-fruchtfolgen-berechnung-frucht-' + num.toString() + '">Frucht</label><select id="C-fruchtfolgen-berechnung-frucht-' + num.toString() + '"></select>';
	divNode.innerHTML = txts;
	parEle.appendChild(divNode);

	// Events hinzufuegen
	document.getElementById('C-fruchtfolgen-berechnung-' + num.toString()).addEventListener('change', function() { // Click auf die Gruppe
		loadCFruchtfolgeFrucht(num); // Laden der jeweiligen Fruechte der Gruppe
	});

	document.getElementById('C-fruchtfolgen-berechnung-frucht-' + num.toString()).addEventListener('change', function() { // Click auf die Frucht
		loadCFruchtfolgeMethode(num); // Laden der jeweiligen Methode der Gruppe
	});

	document.getElementById('C-fruchtfolgen-berechnung-remove-' + num.toString()).addEventListener('click', function() { // Click auf Loeschen-Button
		removeCFruchtfolgeGlied(num);
		setCFaktor('C-fruchtfolgen-berechnung');
	});
	
	loadCFruchtfolge(num);
	
}


function removeCFruchtfolgeGlied(num) {
	var ele = document.getElementById('C-fruchtfolgen-berechnung-glied-' + num.toString()).remove();
	//var ele = document.getElementById('C-fruchtfolgen-berechnung-anteil-' + num.toString()).remove();
	
	// Neue Durchnummerierung:
	var fruchtfolgelist = document.querySelectorAll('.C-fruchtfolgen-berechnung-glied');
	
	for (var i = 1; i < fruchtfolgelist.length; i++) {
		var mainEle = fruchtfolgelist[i];
		var idNum = mainEle.id.substring(mainEle.id.lastIndexOf('-') + 1);
		var numNew = i + 1;
		var fruchtText = getTextFromSelected(mainEle.querySelector('#C-fruchtfolgen-berechnung-frucht-' + idNum.toString()));
		mainEle.querySelector('label>span').innerHTML = 'Feldfrucht im Jahr ' + numNew.toString() + ": " + fruchtText;
	}
}

function insertDataCDauerkulturenMitNutzungsdauer(data, id) {
	var txts = '';
	for (var rec in data.Nutzungsdauer) { // Wahl der Nutzungsdauer
		txts += '<option value="' + data.Nutzungsdauer[rec] + '">' + rec + '</option>';
	}
	var ele = document.getElementById(id);
	ele.innerHTML = txts;
	
	ele.addEventListener('change', function() {
		setCFaktor(this.getAttribute('id'));
	});

}

function insertDataCHopfen(data, id) {
	var txts = '';
	_chopfenTab = data.chopfen;
	// id = "C-dauerkulturen-hopfen";
	for (var rec in _chopfenTab) { // Wahl der Bearbeitungsgänge
		txts += '<option value="' + _chopfenTab[rec].AnzahlBearbeitung + '">' + _chopfenTab[rec].AnzahlBearbeitung + '</option>';
	}
	var ele = document.getElementById(id);
	ele.innerHTML = txts;

	ele.addEventListener('change', function() {
		loadCHopfenMethoden(getValueFromSelected(ele));
		setCFaktor(this.getAttribute('id'));
	});
	document.getElementById(id + '-untersaat').addEventListener('change', function() {
		//setCFaktor(this.getAttribute('id'));
		setCFaktor(id);
	});

	loadCHopfenMethoden(getValueFromSelected(ele));
	setCFaktor(id);
}

function loadCHopfenMethoden(AnzahlBearbeitung) {
	//Moegliche Einstellungen, Checkboxen
	var untersaat0 = false;
	var untersaat1 = false;
	for (var i = 0, len = _chopfenTab.length; i < len; i++) {
		if (_chopfenTab[i].AnzahlBearbeitung == AnzahlBearbeitung) {
			for (var rec in _chopfenTab[i].Methoden) {
				if (rec.indexOf('Untersaat0') >= 0) untersaat0 = true;
				if (rec.indexOf('Untersaat1') >= 0) untersaat1 = true;
			}
			break;
		}
	}

	// Kann gewaehlt werden:
	var ele = document.getElementById('C-dauerkulturen-hopfen-untersaat');
	if (untersaat0 == true && untersaat1 == true) {
		ele.disabled = false;
		ele.checked = true; // Vorauswahl mit Untersaat
	} else {
		ele.disabled = true;
		// Es kann nicht gewaehlt werden, was muss vorselektiert sein?
		if (untersaat1 == true) ele.checked = true;
		else ele.checked = false;
	}

}

function insertDataCWein(data, id) {
	_cweinTab = data.cwein;

	document.getElementById(id).addEventListener('change', function() {
		loadCWeinAnbauform(getValueFromSelected(this), this.getAttribute('id'));
		setCFaktor(this.getAttribute('id'));
	});
	document.getElementById(id + '-anbauform').addEventListener('change', function() {
		//setCFaktor(this.getAttribute('id'));
		setCFaktor(id);
	});

	loadCWeinAnbauform(getValueFromSelected(id), id);
	setCFaktor(id);
}

function loadCWeinAnbauform(anlage, id) {
	var txts = '';
	for (var i = 0, len = _cweinTab.length; i < len; i++) {
		if (_cweinTab[i].Anlage == anlage) {
			for (var rec in _cweinTab[i].Anbauform) {
				txts += '<option value="' + _cweinTab[i].Anbauform[rec] + '">' + rec + '</option>';
			}
			var ele = document.getElementById(id + '-anbauform');
			ele.innerHTML = txts;
			break;
		}
	}
}

// --------------------------
// * C-Auswerten
// --------------------------

function setCFaktor(val) {
	//console.log("Funktion setCFaktor: " + val); // val C-fruchtfolgen-berechnung
	var faktor = getFaktor(val);
	var methode = getMethode(val);

	var cfaktor = 0;
	var text = '';
	var id = faktor + '-' + methode; // z.B. "C-fruchtfolgen"

	var printObj = {};
	printObj.Method = document.getElementById(id).innerHTML; // Radio-Button-Text
	printObj.Para = [];
	_rPrintTexte.C.Methods = [];
	_rPrintTexte.C.Methods.push(printObj);
	

	switch (methode) {
		case 'fruchtfolgen':
			var berechnung = getSubMethode(val); // Berechnung oder deutscher Mittelwert
			var text = document.getElementById(val).innerHTML; // Button-Text bei Fruchtfolgekulturen
			storeToPrint(printObj, 'Berechnung', text);
			
			cfaktor = setCFaktorFruchtfolgenDauerkulturen(val, printObj);
			break;
		case 'dauerkulturen':
		
			// Legend-Text als naehere Bezeichnung
			var legendText = document.getElementById('section-' + val).getElementsByTagName('legend')[0].innerHTML;
			storeToPrint(printObj, 'Anbausystem', legendText);
		
			cfaktor = setCFaktorFruchtfolgenDauerkulturen(val, printObj);
			break;
		case 'faktor':
			cfaktor = document.getElementById(id + '-faktor').value;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, cfaktor);
			break;
	}
	//console.log(cfaktor);
	fillValuesInPage(faktor, cfaktor);
}

function setCFaktorFruchtfolgenDauerkulturen(val, printObj) {
	var faktor = getFaktor(val);
	var methode = getMethode(val);
	var fruchtfolge = getSubMethode(val);

	var id = faktor + '-' + methode + '-' + fruchtfolge; // z.B. "C-fruchtfolgen-deutschermittelwert", "C-fruchtfolgen-fruchtfolge", C-dauerkulturen-hopfen
	//console.log("setCFaktorFruchtfolgenDauerkulturen: " + id);
	var text = '';
	var text2 = '';
	var cfaktor = -1;
	var subId;

	switch (fruchtfolge) {
		case 'berechnung':
			cfaktor = calcCFruchtfolge(val);
			var fruchtfolgelist = document.querySelectorAll('.C-fruchtfolgen-berechnung-glied');
			fruchtfolgelist.forEach(function (ele) {
				var num = ele.id.substring(ele.id.lastIndexOf('-') + 1);

				// Nummer des Fruchtfolgegliedes
				var labelSpan = document.querySelector('#C-fruchtfolgen-berechnung-glied-' + num.toString()).querySelector('label>span');
				text = labelSpan.innerHTML;
				text = text.substring(0,text.indexOf(":"));
				storeToPrint(printObj, text, "");

				subId = "C-fruchtfolgen-berechnung-" + num;
				text = getLabelTextFromFormEle(subId);
				text2 = getValueFromSelected(subId);
				if (text2.indexOf('auswählen') !== -1) {
					text2 = "";
				}
				storeToPrint(printObj, text, text2);

				subId = "C-fruchtfolgen-berechnung-frucht-" + num;
				text = getLabelTextFromFormEle(subId);
				//storeToPrint(printObj, text, getValueFromSelected(subId));
				storeToPrint(printObj, text, getTextFromSelected(subId));

				// Wenn Methode vorhanden
				subId = "C-fruchtfolgen-berechnung-methode-" + num;
				var ele = document.getElementById(subId);
				if (ele != null) {
					text = getLabelTextFromFormEle(subId);
					storeToPrint(printObj, text, getTextFromSelected(ele));
					storeToPrint(printObj, "Gamma-Wert", getValueFromSelected(ele)); // abgeschnitten to fixed bei Funktion loadDetail
				} else {
					// Der Gamma-Wert steht in der Frucht
					storeToPrint(printObj, "Gamma-Wert", getValueFromSelected("C-fruchtfolgen-berechnung-frucht-" + num)); // abgeschnitten to fixed bei Funktion loadDetail
				}

				storeToPrint(printObj, "", ""); // Ein Abstand zum naechsten Fruchtfolgeglied wegen Lesbarkeit

			});
			
			break;
		case 'miscanthus':
		case 'silphie':
			ele = document.getElementById(id);
			text = getLabelTextFromFormEle(id);
			storeToPrint(printObj, text, getTextFromSelected(ele));
			cfaktor = parseFloat(getValueFromSelected(ele)).toFixed(2);
			break;
		case 'hopfen':
			var bearbeitung = getValueFromSelected(id);
			text = getLabelTextFromFormEle(id);
			storeToPrint(printObj, text, bearbeitung);

			var untersaat = document.getElementById(id + '-untersaat').checked;
			text = getLabelTextFromFormEle(id + '-untersaat');
			storeToPrint(printObj, text, getTextFromBoolean(untersaat));

			cfaktor = calcCHopfen(bearbeitung, untersaat);
			break;
		case 'wein':
			var anlage = getTextFromSelected(id);
			text = getLabelTextFromFormEle(id);
			storeToPrint(printObj, text, anlage);
		
			ele = document.getElementById(id + '-anbauform');
			cfaktor = getValueFromSelected(ele);
			text = getLabelTextFromFormEle(id + '-anbauform');
			storeToPrint(printObj, text, getTextFromSelected(ele));
			break;
		case 'gruenland':
			cfaktor = 0.004;
			document.getElementById(id).innerHTML = cfaktor;
			text = getLabelTextFromFormEle(id);
			storeToPrint(printObj, text, cfaktor);
			break;
		case 'wald':
			cfaktor = 0.004;
			document.getElementById(id).innerHTML = cfaktor;
			text = getLabelTextFromFormEle(id);
			storeToPrint(printObj, text, cfaktor);
			break;
		case 'deutschermittelwert':
			cfaktor = 0.126;
			document.getElementById(id + '-faktor').innerHTML = cfaktor;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, cfaktor);
			break;
	}
	
	//console.log(printObj);

	return cfaktor;
}

// --------------------------
// * C-Berechnen
// --------------------------


function calcCFruchtfolge(val) {
	
	var fruchtfolgelist = document.querySelectorAll('.C-fruchtfolgen-berechnung-glied');

	// Anzahl der Fruchtfolgeglieder; Annahme: Anteil immer gleich
	var anzahlGlieder = fruchtfolgelist.length; 

	/* Nebenbedingungen */
	// Die Summe von  fi (Mulch- + Mulchdirektsaat)  muss kleiner oder gleich sein der Summe  von  fi (Winterkulturen + Sommergetreide)
	// Bei rasenbildendem Ackerfutter muss die  Summe von  fi (mehrjähriger Anbau, 1. Jahr nach Etablierung durch Blanksaat oder Untersaat)
	// größer oder gleich sein der Summe  von  fi (mehrjähriger Anbau, 2. Jahr) und so weiter
	var sumWinterundSommerGetreide = 0;
	var sumMulchSaat = 0;
	var ackerfutter = [];
	var isFilledOut = true;
	fruchtfolgelist.forEach(function (ele) {
		var num = ele.id.substring(ele.id.lastIndexOf('-') + 1);
		var gruppe = getValueFromSelected("C-fruchtfolgen-berechnung-" + num.toString());
		
		if (gruppe.indexOf('auswählen') !== -1) {
			isFilledOut = false;
		}

		if (gruppe == "Winterkulturen" || gruppe == "Sommergetreide") {
			sumWinterundSommerGetreide++;
		}

		var frucht = getTextFromSelected("C-fruchtfolgen-berechnung-frucht-" + num.toString()); // in Value kann schon der Gamma-Wert stehen
		var methode = getTextFromSelected("C-fruchtfolgen-berechnung-methode-" + num.toString());
		
		if (methode == "Mulchsaat" || methode == "Mulchdirektsaat") {
			sumMulchSaat++;
		}
		
		// Zusammenhaengender Ackerfutteranbau
		if (gruppe.indexOf('rasenbildende Kulturen') !== -1 && frucht.indexOf('mehrjährig') !== - 1) {
			var jahr = frucht.substr(frucht.indexOf('Jahr') - 3,1);
			//console.log(frucht + " : " + jahr);
			ackerfutter.push(parseInt(jahr));
		}
		
	});
	
	ackerfutter.sort(function(a, b){return a-b});
	
	
	// Testen:
	if (sumMulchSaat > sumWinterundSommerGetreide) {
		// Wenn hier der Hinweis, dann kommt es dauernd!
		//_cHinweis = 'Bedingung Winterkulturen/Sommergetreide und Mulch- + Mulchdirektsaat stimmt nicht.';
	}
	
	var i = 0;
	var ackerfutterTest = true;
	while (i < ackerfutter.length) {
		if (ackerfutter[i] != i + 1) {
			ackerfutterTest = false;
		}
		i++;
	}
	if (ackerfutterTest == false) {
		//_cHinweis = 'Bei Kleegras (u.a.) im mehrjährigen Anbau sind die Anbaujahre nicht vollständig aufgelistet.';
	}
	
	if (_cHinweis != null) {
		Snackbar.show(_cHinweis, 'OK');
		_cHinweis = null;
	}
	
	// Berechnung des C-FAktors
	var sum = 0;
	var gammaEle;
	var num;

	fruchtfolgelist.forEach(function (ele) {
		num = ele.id.substring(ele.id.lastIndexOf('-') + 1);
		
		// Gamma-Wert steht entweder in der Methode (wenn diese existiert ansonsten in der Frucht
		gammaEle = ele.querySelector('#C-fruchtfolgen-berechnung-methode-' + num.toString());
		if (gammaEle == null) {
			gammaEle = ele.querySelector('#C-fruchtfolgen-berechnung-frucht-' + num.toString());
		}
		
		sum = sum + (1/anzahlGlieder * getValueFromSelected(gammaEle));
		
	});
	sum = Math.max(0.025, sum).toFixed(3);
	
	if (isFilledOut == false) {
		sum = 0;
	}
	
	return sum;
	
}

function calcCHopfen(bearbeitung, untersaat) {
	var value = -1;
	var untersaat = 'Untersaat' + String(bool2int(untersaat));
	
	for (var i = 0, len = _chopfenTab.length; i < len; i++) {
		if (_chopfenTab[i].AnzahlBearbeitung == bearbeitung) {
			for (var key in _chopfenTab[i].Methoden) {
				if (key == untersaat) {
					value = _chopfenTab[i].Methoden[key];
				}
			}
			break;
		}
	}
	return value;
}
//************************************************
// * P Bearbeitungsrichtung
//************************************************

// ----------------------------
// * P-Initialisieren und Laden
// ----------------------------
function initP(val) {
	// Daten laden
	loadData(_folder + 'pquerrauhigkeit.json', 'P-quer-oberflaechenrauhigkeit', insertData, 1, val);

	// Zuweisung von Events
	// Radio-Button
	var arr = Array.prototype.slice.call(document.getElementsByClassName('PRad'));
	arr.forEach(function (ele) {
		ele.addEventListener('click', function () {
			loadP(this.getAttribute('id'));
		});
	});

	document.getElementById('P-quer-oberflaechenrauhigkeit').addEventListener('change', function () {
		setPFaktor(this.getAttribute('id'));
	});

	initInputRange(document.getElementById('section-P').getElementsByTagName('input'), sliderChange, sliderStop, slidertxtChange);
	initABAGhelp(document.getElementById('section-P').getElementsByClassName('helpbutton'));
	loadP(val);
}

function loadP(val) {
	// Wenn ueber runde Buttons nur Laden des Faktors
	console.log("loadP " + val);					  
	Snackbar.close(); // Wenn man von einer Karte kommt, können nich Infos über die Snackbar da sein...
	var faktor = getFaktor(val);
	if (getMethode(val) == null) {
		var methode = getSelectedMethodeFromRad(faktor + 'Rad');
		val = faktor + '-' + methode;
	}
	displayFaktorMethode(val);
	setPFaktor(val);
}

// --------------------------
// * P-Auswerten
// --------------------------

function setPFaktor(val) {
	var faktor = getFaktor(val);
	if (faktor == null) faktor = 'P';
	if (isPageLoaded(faktor) == false) return;

	var methode = getMethode(val);
	if (methode == null) {
		methode = getSelectedMethodeFromRad(faktor + 'Rad');
	}

	var pfaktor = 0;
	var text = '';
	var id = faktor + '-' + methode; // z.B. "C-fruchtfolgen"

	//_rPrintTexte.P.Method = document.getElementById(id).innerHTML; // Radio-Button-Text

	var printObj = {};
	printObj.Method = document.getElementById(id).innerHTML; // Radio-Button-Text
	printObj.Para = [];
	_rPrintTexte.P.Methods = [];
	_rPrintTexte.P.Methods.push(printObj);

	switch (methode) {
		case 'gefaelle':
			// Faktor ist hier 1
			pfaktor = (1).toFixed(2);
			document.getElementById(id + '-faktor').innerHTML = pfaktor;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, pfaktor);
			break;
		case 'quer':
			ele = document.getElementById(id + '-oberflaechenrauhigkeit');
			text = getLabelTextFromFormEle(id + '-oberflaechenrauhigkeit');
			storeToPrint(printObj, text, getTextFromSelected(ele));

			var oberflaechenrauhigkeit = getValueFromSelected(ele);

			// Kartoffel-Fruchtfolge?
			var kartProzent = 0;
			var Cmethode = getSelectedMethodeFromRad('CRad');
			if (Cmethode == 'fruchtfolgen') {
				// neu: stimmt das so?
				var kartoffelCount = 0;
				var fruchtfolgelist = document.querySelectorAll('.C-fruchtfolgen-berechnung-glied');
				fruchtfolgelist.forEach(function (ele) {
					var num = ele.id.substring(ele.id.lastIndexOf('-') + 1);
					var gruppe = getValueFromSelected("C-fruchtfolgen-berechnung-" + num.toString());
					var frucht = getTextFromSelected("C-fruchtfolgen-berechnung-frucht-" + num.toString()); // in Value kann schon der Gamma-Wert stehen

					if (gruppe == "Reihenkulturen" && frucht == "Kartoffeln") {
						kartoffelCount++;
					}

				});
				if (kartoffelCount > 0) {
					kartProzent = parseInt(kartoffelCount / fruchtfolgelist.length * 100);
					text = "Kartoffelanteil";
					storeToPrint(printObj, text, kartProzent + " %");
				}
				/*
				var CId = 'C-' + Cmethode;
				CId += '-' + getValueFromSelected(CId + '-anbausystem');
				if (getSubMethode(CId) == 'fruchtfolge' && CId.split('-')[3] == 'kartoffel') {
					// bei fruchtfolge fehlt nun noch die frucht selbst..
					CId = CId + '-Anteil';
					kartProzent = getTextFromSelected(CId);
					kartProzent = parseInt(kartProzent.substring(0, kartProzent.indexOf('%')));
					text = getLabelTextFromFormEle(CId);
					storeToPrint(printObj, text, kartProzent);
				}
				*/
			}
			pfaktor = calcPQuer(oberflaechenrauhigkeit, kartProzent, printObj);
			break;
		case 'faktor':
			//console.log("asdf " + id);
			pfaktor = document.getElementById(id + '-faktor').value;
			text = getLabelTextFromFormEle(id + '-faktor');
			storeToPrint(printObj, text, pfaktor);
			break;
	}
	fillValuesInPage(faktor, pfaktor);
}

// --------------------------
// * P-Berechnen
// --------------------------
function calcPQuer(oberflaechenrauhigkeit, kartProzent, printObj) {
	console.log('' + oberflaechenrauhigkeit + ' : ' + kartProzent);
	var pQuer = 0;
	if (_gesNeig > 0) {
		var pOhneKart = 1;
		switch (oberflaechenrauhigkeit) {
			case '1': // oberflaechenrauhigkeit 0 - 2,5 cm
				pOhneKart = 1;
				break;
			case '2': // oberflaechenrauhigkeit 2,5 - 7,5 cm
				pOhneKart = Math.min(1.0, 0.8 - 0.069 * _gesNeig + 0.0045 * Math.pow(_gesNeig, 2));
				break;
			case '3': // oberflaechenrauhigkeit 7,5 - 12,5 cm
				pOhneKart = Math.min(1.0, 0.34 - 0.023 * _gesNeig + 0.0016 * Math.pow(_gesNeig, 2) + 0.12 / _gesNeig);
				break;
			case '4': // oberflaechenrauhigkeit > 12,5 cm
				pOhneKart = Math.min(1.0, 0.18 - 0.024 * _gesNeig + 0.0013 * Math.pow(_gesNeig, 2) + 0.21 / _gesNeig);
				break;
		}
		//Wichtung von P- Faktor von Kartoffeln und sonstiger FF
		pKart = Math.min(1.0, 0.18 - 0.024 * _gesNeig + 0.0013 * Math.pow(_gesNeig, 2) + 0.21 / _gesNeig);
		pQuer = (kartProzent * 6.0 * pKart + (1.0 - kartProzent) * pOhneKart) / (5.0 * kartProzent + 1.0);
	}

	//Gesamt P
	var HLKrit = Math.round(170.0 * Math.exp(-0.13 * _gesNeig));
	document.getElementById('P-quer-kritLaenge').innerHTML = HLKrit;

	var text = getLabelTextFromFormEle('P-quer-kritLaenge');
	storeToPrint(printObj, text, HLKrit);

	var eff = 1;
	if (_gesLaenge > 0) {
		eff = Math.min(1.0, Math.pow(HLKrit / _gesLaenge, _expM + 1));
	}
	var pfaktor = 1.0 + eff * (pQuer - 1.0);

	// Bewirtschaftungshinweis
	document.getElementById('P-quer-hinweis').classList.add('hidden');

	if (_gesLaenge / HLKrit > 2 && pQuer < 1) {
		var effNeu = Math.min(1.0, Math.pow((2 * HLKrit) / _gesLaenge, _expM + 1));
		var deltaAbtrag = ((Math.pow(0.5, _expM) * (1.0 + effNeu * (pQuer - 1))) / pfaktor) * 100;

		if (deltaAbtrag < 100) {
			document.getElementById('P-quer-hinweis-kritLaenge').innerHTML = HLKrit.toFixed(0) + ' m';
			document.getElementById('P-quer-hinweis-deltaAbtrag').innerHTML = deltaAbtrag.toFixed(0) + ' %';
			document.getElementById('P-quer-hinweis').classList.remove('hidden');
		}
	}

	return pfaktor.toFixed(2);
}

//************************************************
//** Drucken, Darstellen
//************************************************

function getLabelTextFromFormEle(id) {
	var nodeList = document.getElementsByTagName('label');
	for (var i = 0, len = nodeList.length; i < len; i++) {
		if (nodeList[i].htmlFor == id) {
			return nodeList[i].innerHTML;
		}
	}
	return '';
}

function storeToPrint(storObj, text, val) {
	var obj = {};
	obj.Text = text; // Label
	obj.Value = val; // hier der Wert
	storObj.Para.push(obj);
}

function fillValuesInPage(faktor, value) {
	// allgemein
	var ele = document.getElementById('txt-' + faktor);
	if (ele == null) return;
	ele.innerHTML = value;

	// Zusaetzliches
	switch (faktor) {
		case 'P':
			document.getElementById('P-quer-gesNeig').innerHTML = _gesNeig.toFixed(1);
			document.getElementById('P-quer-gesLaenge').innerHTML = _gesLaenge;
			break;
	}

	/*
    switch (faktor) {
    	case "toleranz":
    		$("#txt-toleranz").html(_toleranz.toFixed(1));
    		break;
    	case "hangform":
    		$("#txt-hangform").html(_lsfaktor);
    		$("#brichtung-hangform-gesNeig").html(_gesNeig.toFixed(1));
    		$("#brichtung-hangform-gesLaenge").html(_gesLaenge);
    		break;
    }
    */
}

//************************************************
//** Utilities
//************************************************

// Aufloesen der id, z.B. C-fruchtfolgen-faktor, C-fruchtfolgen-fruchtfolge-maehdrusch
function getFaktor(id) {
	if (typeof id === 'undefined') return null;
	if (id.indexOf('-') !== -1) {
		return id.substring(0, id.indexOf('-'));
	} else {
		return id;
	}
}

function getMethode(id) {
	if (typeof id === 'undefined') return null;
	var val = id.split('-');
	if (val.length >= 2) {
		return val[1];
	}
	return null;
	//var faktor = (val.indexOf("-") === -1) ? val : val.substring(0,val.indexOf("-")); // C
	//var val = (val.indexOf("-") === -1) ? "" : val.substring(val.indexOf("-") + 1);
	//var methode = (val.indexOf("-") === -1) ? val : val.substring(0,val.indexOf("-")); // Jeweiliger Unterpunkt konventionell - oekologisch - faktor
}

function getSubMethode(id) {
	var faktor = getFaktor(id);
	var val = id.split('-');

	switch (faktor) {
		case 'K':
			// Hier ist die Submethode der 4. Wert
			if (val.length >= 4) {
				return val[3];
			}
			break;
		default:
			//console.log(faktor + " : " + id);
			if (val.length >= 3) {
				return val[2];
			}
			break;
	}
	return null;
}

function getSelectedMethodeFromRad(rad) {
	var arr = Array.prototype.slice.call(document.getElementsByClassName(rad));
	var methode = '';
	arr.forEach(function (ele) {
		if (ele.classList.contains('radchecked')) {
			methode = getMethode(ele.getAttribute('id'));
		}
	});
	return methode;
}

function getSelectedSubMethodeFromRad(rad) {
	var arr = Array.prototype.slice.call(document.getElementsByClassName(rad));
	var methode = '';
	arr.forEach(function (ele) {
		if (ele.classList.contains('radchecked')) {
			methode = getSubMethode(ele.getAttribute('id'));
		}
	});
	return methode;
}

function getTextFromSelected(id) {
	if (typeof id == 'string') id = document.getElementById(id);
	if (id == null) return null;
	if (id.selectedIndex == -1) return null;
	return id.options[id.selectedIndex].text;
}

function getTextFromBoolean(val) {
	if (val) return "ja";
	else return "nein";
}
function getValueFromSelected(id) {
	if (typeof id == 'string') id = document.getElementById(id);
	if (id == null) return null;
	if (id.selectedIndex == -1) return null;
	return id.options[id.selectedIndex].value;
}

function bool2int(val) {
	if (val) return 1;
	else return 0;
}

function getSubstr(str, substr) {
	return str.substring(str.indexOf(substr) + substr.length);
}

function addHTMLFragment(url, id, callback, error, args) {
	var rawFile = new XMLHttpRequest();
	rawFile.open('GET', url, true);
	rawFile.onreadystatechange = function () {
		if (rawFile.readyState === 4 && rawFile.status == '200') {
			if (id != null) {
				document.getElementById(id).innerHTML = rawFile.responseText;
			}
			if (callback && typeof callback === 'function') {
				callback(args, rawFile.responseText, id);
			}
		}
	};
	rawFile.send(null);
}

function loadData(url, id, callback, selectedIndex, args) {
	if (window.Worker) {
		//daten über webworker vorladen
		var worker = new Worker('syslib/js/loadworker.min.js');
		worker.addEventListener(
			'message',
			function (e) {
				e.currentTarget.terminate();
				if (callback && typeof callback === 'function' && e.data != '') {
					//console.log(e.data.length);
					callback(JSON.parse(e.data), id, selectedIndex, args);
				}
			},
			false
		);
		worker.postMessage(['../../' + url, 'json']); // Send data to our worker.
	} else {
		var rawFile = new XMLHttpRequest();
		rawFile.overrideMimeType('application/json');
		rawFile.open('GET', url, true);
		rawFile.onreadystatechange = function () {
			if (rawFile.readyState === 4 && rawFile.status == '200') {
				if (callback && typeof callback === 'function') {
					callback(JSON.parse(rawFile.responseText), id, selectedIndex, args);
				}
			}
		};
		rawFile.send(null);
	}
}

function insertData(data, id, selectedIndex) {
	var txts;
	for (var rec in data) {
		txts += '<option value="' + data[rec] + '">' + rec + '</option>';
	}
	var ele = document.getElementById(id);
	ele.innerHTML = txts;

	if (typeof selectedIndex != 'undefined') {
		ele.selectedIndex = selectedIndex;
	}
}
